// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/component.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/tick-circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 200 12%27 preserveAspectRatio=%27none%27%3E%3Cpath d=%27M2 8 C 55 1, 150 1, 198 6%27 stroke=%27%23e3bd3e%27 stroke-width=%273%27 fill=%27none%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 32%27%3E%3Cg stroke=%27%23e3bd3e%27 stroke-width=%272.4%27 stroke-linecap=%27round%27 fill=%27none%27%3E%3Cpath d=%27M21 5 L12 10%27/%3E%3Cpath d=%27M23 16 L13 16%27/%3E%3Cpath d=%27M21 27 L12 22%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cus-err {
    color: #D8000C;
    position: absolute;
    left: 5px;
    bottom: 0px;
    font-size: 13px;
}

.innerFormBox .box-box,
.boxFull,
.fillDetails .nameBox .box-box {
    position: relative;
}

.innerFormBox .box-box .cus-err,
.boxFull .cus-err {
    bottom: -20px;
}

/*  */
.iti,
.iti--allow-dropdown {
    width: 100%;
    margin-bottom: 20px;
}

.reg-g-captcha-main {
    position: relative;
    padding: 10px 0 20px;
}

.iti__tel-input {
    width: 100%;
    padding: 10px 15px;
    border-radius: 12px;
    outline: none !important;
    box-shadow: none !important;
    border: 2px solid #E6E8EC;
    /* margin-bottom: 15px; */
    margin-bottom: 20px;
}

/* Loader */
.preloader {
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 2000 !important;
}

.preloader span {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px;
    margin-top: 15px;
}

.preloader .preloader-icon,
.inside-loader .preloader-icon {
    border: 2px solid #eeeeee;
    border-radius: 50%;
    border-top: 2px solid #E3BD3E;
    width: 70px;
    height: 70px;
    animation: spin 0.5s linear infinite !important;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* .no-scroll {
    overflow: hidden;
} */

/* Loader Ends */
.commonInput.greenSpan {
    border: 2px solid #2ABC30 !important;
}



.adultDropBox {
    max-height: 0;
    /* overflow: hidden; */
    transition: max-height 0.2s ease-in-out;
}


/* .adultDropBox {
    display: block;
} */
.bookRightBox .selectDate .multyDrop .adultDropBox ul {
    background-color: white;
}

@keyframes slideDown {
    from {
        max-height: 0;
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        max-height: 150px;
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideUp {
    from {
        max-height: 150px;
        opacity: 1;
        transform: translateY(0);
    }

    to {
        max-height: 0;
        opacity: 0;
        transform: translateY(-20px);
    }
}

.adultDropBox.open,
.dateBoxLeft.open,
.timeDropBox.open {
    display: block;
    animation: slideDown 0.2s ease-out forwards;
}

.adultDropBox.close,
.dateBoxLeft.close,
.timeDropBox.close {
    animation: slideUp 0.2s ease-out forwards;
}

.flatpickr-input {
    padding: 20px 20px;
    box-shadow: 0px 0px 10px var(--border-color) !important;
    border-radius: 15px;
    background: white;
}

body.dark .flatpickr-input {
    background-color: #1f1f1f;
}

.detailsSlider .sliderImg {
    max-height: 550px;
}

.accessibleBox .typecheck .form-check-input:checked,
.form-radio-warning .form-check-input:checked {
    background-color: #F5A524;
    border-color: #F5A524;
}

.accessibleBox .typecheck .form-check-input {
    box-shadow: none !important;
    outline: none !important;
    margin-right: 10px;
    height: 20px;
    width: 20px;
    border: 2px solid var(--border-color);
}

.accessibleBox .typecheck {
    padding-left: 0 !important;
}

.ql-editor {
    width: 100% !important;
    max-width: 100% !important;
    word-break: break-word !important;
    min-height: 150px !important;
}

.boxCard.disabled {
    /* opacity: 0.5; */
    pointer-events: none;
}

.main.disabled {
    cursor: not-allowed;
    background: #fafafa;
    border: 2px solid var(--border-color) !important;
    color: black !important;
}

.suggestUp span.cus-err {
    bottom: -22px !important;
}

.suggestUp {
    position: relative !important;
}

.bokunDropBox .DropBox li a .langflag {
    margin-right: 10px;
    height: 15px;
    width: 15px;
}

.bokunDropBox .DropBox li a .langflag img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.DropBox {
    top: 60px !important;
}

.css-t3ipsp-control {
    border: 1px solid var(--gold-color) !important;
    box-shadow: 0 0 0 1px var(--gold-color) !important;
}

.css-13cymwt-control {
    border: 2px solid var(--border-color) !important;
}

.css-v7duua:hover {
    background-color: var(--gold-color) !important;
    color: black !important;
}

#exampleModal .modal-title {
    font-family: 'Manrope-SemiBold' !important;
}

.bookingCategory.bookingCategorydesktop.privateBox .commongridbox {
    grid-template-columns: 420px 1fr 1fr;
}

.seatsBox .commonLabelSecond i {
    line-height: normal;
}

.bookingCategory .commongridbox {
    align-items: center;
}

.bookingCategory .commongridbox .commonLabelSecond {
    padding-bottom: 0;
}

.rate_title .commonLabelSecond {
    display: flex;
    align-items: center;
    justify-content: start;
}

.rate_title .commonLabelSecond i {
    font-size: 18px;
    /* margin-right: 15px; */
    color: #94A3B8 !important;
    vertical-align: middle;
    float: left;
    margin: 0 15px 0 0px !important;
}

.tripPrices .costBox table td.commisoin {
    padding: 15px !important;
}

.costBox .table>:not(:last-child)>:last-child>* {
    border-bottom: none !important;
}


.table-striped>tbody>tr:nth-of-type(odd) {
    --bs-table-accent-bg: unset !important;
}


.table-striped>tbody>tr:nth-of-type(even) {
    --bs-table-accent-bg: var(--bs-table-striped-bg) !important;
}


.dateBoxLeft .dayContainer {
    gap: 5px !important;
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
    fill: unset !important;
}


.prevMonthDay {
    visibility: hidden !important;
}

.nextMonthDay {
    visibility: hidden !important;

}

.dateBoxLeft .flatpickr-calendar {
    box-shadow: unset !important;

}

.available-date {
    background-color: #FDF7E8 !important;
    color: #334155 !important;
    /* border-radius: 50% !important;  */
}

/* Dot under the highlighted date */
.bookable-date::after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    background-color: #ECBB33 !important;
    border-radius: 50%;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
}

.flatpickr-day {
    border-radius: 10px !important;
    font-family: 'Manrope-SemiBold' !important;
    /* Make the input square */
}

.flatpickr-day.selected {
    background-color: #ECBB33 !important;
    color: #44444F !important;
    border-color: #ECBB33 !important;
}

.flatpickr-day.selected.bookable-date::after {
    background-color: #44444F !important;

}

.dateBoxLeft .flatpickr-current-month {
    width: 64% !important;
    left: 0 !important;
}

.dateBoxLeft .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {
    left: 75% !important;
}

.dateBoxLeft .flatpickr-prev-month,
.dateBoxLeft .flatpickr-next-month {
    border: 2px solid #E6E8EC !important;
    padding: 3px 9px !important;
    border-radius: 8px !important;
    box-shadow: 0px 1px 2px #0D0D120F !important;
}

.dateBoxLeft .flatpickr-prev-month svg,
.dateBoxLeft .flatpickr-next-month svg {
    width: 12px !important;
    height: 12px !important;
}

.dateBoxLeft select.flatpickr-monthDropdown-months,
input.cur-year {
    font-family: 'Nunito', sans-serif !important;
    font-weight: 700 !important;
}

.dateBoxLeft .flatpickr-months {
    margin-bottom: 10px;
    /* padding-bottom: 15px; */
    border-bottom: 1px solid #E6E8EC;
}

.dateBoxLeft .commonLabelSecond {
    padding-bottom: 0 !important;
    margin-bottom: 10px !important;
}

.commonGoldBtn {
    background-color: #E3BD3E !important;
}

.custom-ui {
    text-align: center;
    width: 500px;
    padding: 40px;
    /* background: #28bae6; */
    background-color: var(--gold-color);
    color: var(--text-black) !important;
    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);
    /* color: #fff !important; */
    border-radius: 10px !important;
}

.custom-ui>button {
    width: 160px !important;
    padding: 10px !important;
    border: 1px solid #fff;
    margin: 10px !important;
    cursor: pointer;
    background: none;
    color: #fff;
    font-size: 14px;
}

.custom-ui>h1 {
    font-family: 'Manrope-SemiBold' !important;
    margin-top: 0;
    color: #fff;
    font-size: 2.5rem !important;

}

.custom-ui>p {
    margin-top: 0;
    color: #fff;

}

.imgText {
    cursor: pointer !important;
}

.custom-ui button:hover {
    background: white !important;
    color: var(--gold-color) !important;
}

.activityMain .activityFillSec .mainTabBox .nav .nav-link.mainLink.active::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.activityMain .activityFillSec .mainTabBox .nav .nav-link.mainLink.active.complete::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.discriplangDown a.main .langflag {
    margin-right: 10px;
    height: 15px;
    width: 15px;
}

.discriplangDown a.main .langflag img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.imgUpload .imageImprot .cus-err,
.meetingLoact .uploadBox .cus-err {
    position: absolute;
    bottom: -20px;
}

#allimgBox {
    padding-top: 15px;
}

/*  */
.showList .box-box h5 span.spanCom {
    height: 45px;
    width: 45px;
    display: inline-flex;
    background-color: transparent !important;
    border-radius: 5px;
    margin-right: 15px;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
}

.showList .box-box h5 {
    color: #64748B;
    font-size: unset !important;
    font-family: 'Manrope-SemiBold' !important;
}

.showList .box-box h5 span.yellowBg {
    background-color: #FDF7E8 !important;
    position: relative;
}

.showList .box-box h5 span.yellowBg::after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    background-color: #ECBB33 !important;
    border-radius: 50%;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
}

.showList .box-box h5 span.whiteBg {
    position: relative;
}

.showList .box-box h5 span.whiteBg::after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    background-color: #ECBB33 !important;
    border-radius: 50%;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
}

.showList {
    border-top: 1px solid #E6E8EC !important;
}

.productDuration .dateBoxLeft {
    padding: 0 10px !important;
}

.themeCheck:checked {
    background-color: #E3BD3E !important;
    border-color: #E3BD3E !important;
}

.themeCheck:focus {
    border-color: #E3BD3E;
    outline: 0;
    box-shadow: 0 0 0 .25rem #e3bd3e85 !important
}

.cropper-container {
    width: auto !important;
}

#croppedImage {
    max-width: 600px;
    max-height: 300px;
    width: auto;
    height: auto;
}

.loc-select-input .css-b62m3t-container {
    width: 100% !important;
    margin-right: 10px !important;
}

.location-div .cus-err {
    bottom: -10px;
}

.loginSec input::placeholder {
    color: #BDBDBD !important;
}

.loc-select-input .css-3iigni-container {
    width: 100% !important;
    margin-right: 10px !important;
}

.getOtpBox .cus-err {
    position: relative;
}

.loginSec.signUp .iti {
    display: flex !important;
    gap: 10px !important;
}

.loginSec.signUp .iti__country-container {
    position: unset !important;
    border-radius: 12px;
    border: 2px solid #E6E8EC;
    width: 140px;
}

.loginSec.signUp .iti__tel-input {
    padding-left: 10px !important;
}

.loginSec.signUp .iti__selected-country {
    width: 100%;
}

.loginSec.signUp .iti__arrow {
    border-left: 0 !important;
    border-right: 0 !important;
    margin-left: 0 !important;
}

.iti__arrow::after {
    content: '\\f078';
    font-family: 'fontawesome';
    position: absolute;
    right: 4px;
    font-size: 11px;
    margin-left: 10px;
    height: 25px;
    width: 25px;
    border: 2px solid #E6E8EC;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);
}

.iti .iti__selected-dial-code {
    margin-left: 3px !important;
}

.iti__selected-country-primary {
    padding-right: 0 !important;
}

.iti__selected-country-primary:hover {
    background-color: transparent !important;
}

.iti__search-input {
    outline: none !important;
    border: 2px solid #E6E8EC;
    padding: 10px 15px;
    border-radius: 12px;
}

.req-sym {
    color: #fa5c7c;
    margin-left: 0.3rem;
}

.companyProfilePage .boxCard {
    position: relative;

}

.companyProfilePage .cus-err {
    bottom: -20px;
}

body.dark .activityhead .backBox a,
body.dark .activityhead .backBox a i {
    color: #B1B5C3 !important;
    border-color: #334155 !important;
    background-color: #2C2C2C !important;
}

body.dark .rightTabcontent .pagenext .pageList p {
    color: #B1B5C3 !important;

}

.userAc {
    display: block !important;
}

.select2.select2-container {
    width: 100% !important;
}

.select2.select2-container .selection {
    width: 100% !important;
}

.select2.select2-container .selection .select2-selection {
    border: 2px solid #E6E8EC;
    display: flex;
    align-items: center;
    /* padding: 20px 0px; */
    height: 48px;
    border-radius: 10px;
    /* width: 250px; */
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    top: unset !important;
}

input.select2-search__field {
    outline: 0 !important;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
    background-color: #e3bd3e !important;
    color: #1f1f1f !important;
}

.redColorText {
    color: #950606 !important;
}

.commonLabel {
    width: 100%;
    padding-bottom: 5px;
    color: #292929;
    font-family: 'Manrope-Regular';
}

.dashboard {
    font-family: 'Manrope-Regular';
}

/* Date Picker */

.react-date-picker {
    width: 100%;
}

.react-date-picker__wrapper {
    border: none !important;
    padding: 8px 15px !important;
    border-radius: 12px !important;
    border: 2px solid var(--border-color) !important;
}

.react-date-picker__inputGroup {
    /* color: #7A7C86 !important; */
    font-size: 14px !important;
    font-family: 'Manrope-Medium' !important;
}

.react-date-picker__button svg {
    stroke: #7A7C86 !important;
}

.react-date-picker__button svg:hover {
    stroke: #E3BD3E !important;
}

.react-calendar {
    border: none !important;
    border-radius: 30px;
    background-color: #FCFCFD !important;
    /* box-shadow: 0 40px 32px -24px #0F0F0F1F !important; */
    box-shadow: 0 0px 5px 0px #0F0F0F1F !important;
    padding: 15px 10px !important;
}

.react-calendar__month-view .react-calendar__tile {
    font-size: 14px !important;
    width: 50px !important;
    max-width: 45px !important;
    height: 45px;
    font-family: 'Poppins-Medium' !important;
}

.react-calendar__month-view .react-calendar__tile--active {
    color: #171202 !important;
    border-radius: 50% !important;
    background: #ECBB33 !important;
    padding: 0 !important;
}

/* .react-calendar__month-view__days__day--neighboringMonth {
    color: #171202 !important;
} */

.react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr !important;
}

.react-calendar__month-view .react-calendar__month-view__weekdays {
    color: #83889B !important;
    font-family: 'Gilory-SemiBold' !important;
    text-transform: capitalize !important;
    text-decoration: none !important;
    font-size: 14px !important;
}

.react-calendar__month-view .react-calendar__month-view__weekdays abbr[title] {
    text-decoration: unset !important;
    font-family: 'Gilory-SemiBold' !important;
}

.react-calendar__month-view .react-calendar__month-view__days__day--weekend {
    color: #171202 !important;
}

.react-calendar__navigation .react-calendar__navigation__label__labelText {
    font-size: 18px;
    color: #171202;
    font-family: 'Manrope-Bold' !important;
}

.react-calendar__month-view__days__day--neighboringMonth {
    color: #757575 !important;
}

.react-calendar__tile--now {
    background: transparent !important;
}

.react-calendar__month-view .react-calendar__tile:enabled:hover,
.react-calendar__month-view .react-calendar__tile:enabled:focus {
    /* background-color: #ECBB33 !important; */
    border-radius: 50% !important;
}

.react-calendar__year-view .react-calendar__tile--hasActive,
.react-calendar__decade-view__years .react-calendar__tile--hasActive,
.react-calendar__century-view__decades .react-calendar__tile--hasActive {
    background: #ECBB33 !important;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view__years .react-calendar__tile,
.react-calendar__century-view__decades .react-calendar__tile {
    padding: 12px 20px !important;
    border-radius: 30px;
    color: #171202 !important;
    font-size: 14px !important;
    font-family: 'Gilory-SemiBold' !important;
    /* font-family: 'Gilroy-Bold'!important; */
    margin-bottom: 10px !important;
}

.react-calendar__century-view__decades .react-calendar__tile {
    padding: 12px 5px !important;
}

/* Date Picker End */

.booking-pagination-par .pagenext {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* ========= skaleton css start ========= */

@keyframes skeleton-loading {
    0% {
        background-color: #d6d6d0;
    }

    50% {
        background-color: #e0e0d9;
    }

    100% {
        background-color: #d6d6d0;
    }
}

@keyframes skeleton-loading-dark {
    0% {
        background-color: #2F2304;
    }

    50% {
        background-color: #241b06;
    }

    100% {
        background-color: #2F2304;
    }
}

.skeleton {
    position: relative;
}

.skeleton::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    animation: skeleton-loading 1.5s infinite ease-in-out;
    z-index: 55;
    border-radius: 10px;
}

body.dark .skeleton::after {
    animation: skeleton-loading-dark 1.5s infinite ease-in-out;
}

/* ========= skaleton css end ========= */
.drop-border-unset a {
    border: unset !important;
}

.booking-product-list-select .select2-selection__rendered {
    width: 100% !important;
}

.detailsMore .accordion-body .ourbtnsec .btn.resendbtn {
    color: #292D32;
    background-color: #E3BD3E;
    border: unset;
}

.detailsMore .accordion-body .ourbtnsec .btn.cancelbtn {
    background-color: #DC2626;
    border: unset;
    color: white;

}

.detailsMore span.greenstatuspaid {
    background: #17C964;
    padding: 0px 10px;
    border-radius: 5px;
    font-size: 12px;
    color: black;
    padding: 4px 4px;
}

.detailsMore span.comtagSpan {
    padding: 0px 10px;
    border-radius: 5px;
    font-size: 14px;
    font-family: 'Manrope-SemiBold' !important;
}

.detailsMore span.comtagSpan.green {
    background-color: #17C96433;
    color: #09A54D;
}

.detailsMore span.comtagSpan.blue {
    background-color: #006FEE33;
    color: #006FEE;
}

.detailsMore span.comtagSpan.yellow {
    background-color: #FFE69C;
    /* bright amber background */
    color: #B58100;
    /* strong amber text */
}

.emptyimgBox {
    text-align: center;
    padding: 50px 0 80px;
}

.emptyimgBox h5 {
    color: #23262F;
    font-family: 'Manrope-Bold';
    margin: 20px 0 10px;
}

.emptyimgBox p {
    color: #64748B;
    font-family: 'Manrope-Bold';
    font-size: 14px;
}

.custom-file-upload {
    cursor: pointer;
    color: var(--gold-color);
    text-decoration: none;
    /* font-size: 14px; */
    display: inline-flex;
    align-items: center;
}

.custom-file-upload i {
    margin-right: 5px;
}


.rightProfile .rightProfileMain .userImgBox .updateImg label {
    color: var(--gold-color);
    font-family: 'Manrope-SemiBold';
    margin-top: 10px;
}

#avatarInput {
    display: none;
}

.iti__arrow::after {
    content: '\\f078';
    font-family: 'fontawesome';
    position: absolute;
    right: 4px;
    font-size: 11px;
    margin-left: 10px;
    height: 25px;
    width: 25px;
    border: 2px solid #E6E8EC;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);
}

.iti,
.ourdetailProfile.profileImport .iti {
    display: flex !important;
    gap: 10px !important;
}

.iti__country-container,
.ourdetailProfile.profileImport .iti__country-container {
    position: unset !important;
    border-radius: 12px;
    border: 2px solid #E6E8EC;
    width: 170px;
}

.iti__selected-country,
.ourdetailProfile.profileImport .iti__selected-country {
    width: 100%;
}

.iti__arrow,
.ourdetailProfile.profileImport .iti__arrow {
    border-left: 0 !important;
    border-right: 0 !important;
    margin-left: 0 !important;
}

.iti .iti__selected-dial-code {
    margin-left: 3px !important;
}

.iti__tel-input,
.ourdetailProfile.profileImport .iti__tel-input {
    padding-left: 10px !important;
}

.rightProfile .rightProfileMain .userPersonaldet {
    margin-bottom: 100px;
}

.custom-switch .form-check-input:checked {
    background-color: var(--gold-color);
    border-color: var(--gold-color);
}

.custom-switch .form-check-input:focus {
    box-shadow: unset;
}

.righttableSec .addTeam .btnGold i {
    margin-right: 10px;
    color: #23252E;
}

.righttableSec .addTeam .btnGold {
    background-color: var(--gold-color);
    color: var(--text-black) !important;
}

.commonFileInputSecond {
    /* width: 100%;
    padding: 8px 15px; */
    border-radius: 12px;
    border: 2px solid var(--border-color);
    /* box-shadow: none;
    outline: none;
    height: 48px; */
}

.add-sup-form .cus-err {
    position: relative;
}

.custom-switch .form-check-input:focus {
    border-color: var(--gold-color);
    outline: 0;
    box-shadow: unset;
}

table.teamTable {
    border-collapse: separate;
    border-spacing: 0 0.5em;
}

.importBox .cus-err {
    position: relative;
    bottom: 0px !important;
}

.soarting {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
}

.soarting .icons {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.soarting .icons i {
    font-size: 7px;
    color: #94A3B8;
}

.opacityDown {
    opacity: 0.5;
}

.opacitUp {
    opacity: 0.5;
}

span.red {
    color: #F31260;
    /* Red color */
    background-color: #F3126033;
    /* Light red background */
}

.unpublished-tour {
    background: #f3f3f3;
    opacity: 0.5;
}

.header_sortable {
    cursor: pointer;
}

.header_sortable:hover {
    background: #ebeff3;
}

.b-20 {
    bottom: -20px;
}

.b-3 {
    bottom: -3px;
}

.verification-modal .modal-dialog {
    max-width: 480px;
}

.verification-modal .modal-content {
    border-radius: 16px;
}

.verification-modal .modal-body {
    text-align: center;
    padding: 30px 30px;
}

.verification-modal .modal-body a>img {
    width: 100%;
    max-width: 190px;
}

.verification-modal .modal-body h4 {
    color: #0F172A;
    font-size: 30px;
    margin: 15px 0;
    font-family: 'Gilroy-Bold';
}

.verification-modal .modal-body h6 {
    font-size: 14px;
    color: #94A0AD;
    margin-bottom: 25px;
    font-family: 'Gilroy-Bold';
}

.verification-modal .modal-body .register p {
    color: #475569;
    font-size: 16px;
    font-family: 'Manrope-SemiBold';
    margin-top: 20px;
}

.verification-modal .modal-body .register p a {
    font-family: 'Manrope-SemiBold';
}

.verification-modal.confirmation-modal .modal-dialog {
    max-width: 567px;
}

.verification-modal.confirmation-modal .modal-body h4 {
    color: #23262F;
    font-family: 'Manrope-Bold' !important;
}

.verification-modal.confirmation-modal .modal-body h6 {
    color: #94A3B8;
    font-family: 'Manrope-Bold' !important;
}

.verification-modal.confirmation-modal .continueBox {
    display: flex;
    gap: 10px;
}

.verification-modal.confirmation-modal .continueBox .continueBtn {
    width: calc(50%);
    background: #fff;
    border: 1px solid var(--gold-color);
    font-family: 'Manrope-SemiBold' !important;
}

.verification-modal.confirmation-modal .continueBox .continueBtn:hover {
    background: var(--gold-color);
}

.modal-backdrop.show {
    opacity: .9;
    background-color: #171202;
}

/*  */

.arrow {
    transition: transform 0.3s ease;
}

.arrow.rotate {
    transform: rotate(180deg);
}

.submenu {
    display: block !important;
    max-height: 0;
    padding-top: 0px !important;
    overflow: hidden;
    transition: max-height 0.4s ease-in-out !important;
}

.submenu.open {
    max-height: 200px !important;
    /* Adjust based on submenu content */
}

.mainListProducts .tabBtnbox ul li {
    margin: 10px 0;
}

/* Mobile collapsible sidebar menu (Option A) */
.mobileMenuToggle {
    display: none;
}
@media (max-width: 991px) {
    .mobileMenuToggle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 13px 18px;
        background: #ffffff;
        border: 1px solid #eef0f4;
        border-radius: 12px;
        font-family: 'Manrope-Bold';
        font-size: 15px;
        color: #23252E;
    }
    .mobileMenuToggle span {
        display: inline-flex;
        align-items: center;
        gap: 10px;
    }
    .mobileMenuToggle .toggleArrow {
        transition: transform 0.25s ease;
    }
    .mobileMenuToggle .toggleArrow.open {
        transform: rotate(180deg);
    }
    .leftTabcustom .tabBtnbox {
        display: none;
        margin-top: 12px;
    }
    .leftTabcustom .tabBtnbox.open {
        display: block;
    }
}

.skeleton {
    text-decoration: unset !important;
}

.customBtnGold {
    background: var(--gold-color);
    width: 100px;
    font-family: 'Manrope-Bold';
    border-radius: 30px;
    min-height: 45px;
    color: #23252E;
    outline: unset;
    border: unset;
}

.profileBackbtnContainer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.custom-switch {
    cursor: pointer;
}

.detailsMore .accordion-body .ourbtnsec .btn.two {
    width: calc(50% - 10px);
}

.detailsMore .accordion-body .ourbtnsec .btn.three {
    width: calc(100% - 10px);
}


.detailsMore .accordion-body .ourbtnsec .btn.single {
    width: calc(100%);
}

.rightProfile .rightProfileMain .userPersonaldet ul li span.black {
    word-break: break-all;
}

.flatpickr-day.endRange {
    background: var(--gold-color) !important;
    box-shadow: none !important;
    /* color: #fff; */
    border-color: var(--gold-color) !important;
}

.rangeMode .flatpickr-day {
    border-radius: 0 !important;
}

.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange,
.flatpickr-day.endRange.startRange {
    border-radius: 50px 0 0 50px !important;
}

.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange,
.flatpickr-day.endRange.endRange {
    border-radius: 0 50px 50px 0 !important;
}

.customBtnGold {
    background: var(--gold-color);
    width: 100px;
    font-family: 'Manrope-Bold';
    border-radius: 30px;
    min-height: 45px;
    color: #23252E;
    outline: unset;
    border: unset;
}

.profileBackbtnContainer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.finance_Payment .sub_filter .tour_status_drop {
    min-width: 200px !important;
    width: unset;
}

.finance_Payment .status_select .clickTo input[type="radio"] {
    position: absolute;
    opacity: 0;
    margin-right: 0px;
    left: 0;
    top: 0;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    z-index: 55;
    cursor: pointer;
}

.finance_Payment .status_select .clickTo input[type="radio"]+.keyword-label::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    cursor: pointer;
    height: 20px;
    border: 2px solid #CBD5E1;
    background-color: #fff;
    border-radius: 50%;
}

.finance_Payment .status_select .clickTo input[type="radio"]:checked+.keyword-label::after {
    content: '\\f00c';
    position: absolute;
    font-family: 'fontawesome';
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    color: #000;
    background-color: var(--gold-color);
    width: 20px;
    height: 20px;
    text-align: center;
    border-radius: 50%;
    padding-top: 5px;
}

.finance_Payment .sub_filter .added_filer a:first-child {
    border-right: 0;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

.finance_Payment .sub_filter .added_filer a:nth-child(2) {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
    display: flex;
    align-items: center;
}

.finance_Payment .sub_filter .added_filer a span {
    color: #64748B;
    font-size: 13px !important;
}

.added_filer {
    display: flex;
}

.finance_Payment .sub_filter .added_filer a i {
    margin-left: 0 !important;
}

.finance_Payment .sub_filter .added_filer a:nth-child(2):hover {
    background-color: #d4d4d89e;
}

.topstatus {
    font-size: 12px !important;
    padding: 4px 10px !important;
}

.bottom-0 {
    bottom: 0px !important;
}

.profile_privacy_sec .profile_privacy ul li .text_name {
    display: flex;
    align-items: center;
}

.profile_privacy_sec .profile_privacy ul li .swicth_box .form-switch .form-check-input {
    margin-top: 0;
    cursor: pointer;
}

.exportBtns {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.exportBtns button {
    width: 200px;
}

.exportBtns button:disabled {
    opacity: 0.7 !important;
}

.finance_Payment .select2.select2-container .selection .select2-selection {
    width: 250px;
}

.whatsappbtn {
    background-color: #25D366 !important;
    color: white !important;
    width: 100% !important;
}

.detailsMore .accordion-body .ourbtnsec .btn i {
    vertical-align: initial !important;
}

.form-check-input:checked {
    background-color: #ecbb33;
    border-color: #ecbb33;
}

.form-check-input:focus {
    outline: 0;
    box-shadow: 0 0 0 .25rem #e3bd3e63;
}

.footerPart .footerBox .innerBox .footermenu.fiveBox ul li span img {
    width: 100% !important;
    max-width: 30px !important;
}

/*  */
.settings-wrapper {
    max-width: 900px;
    margin: 2rem auto;
    background: #fff;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.05);
}

.section-header {
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 2rem;
}

.payment-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    padding: 1rem 1.5rem;
    margin-bottom: 1.2rem;
    background-color: #fff;
    transition: box-shadow 0.3s, border-color 0.3s;
}

.payment-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.payment-card.default {
    border: 2px solid var(--gold-color);
    background-color: #fdfaf2;
}

.payment-info {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.payment-icon {
    font-size: 1.8rem;
    color: #333;
}

.payment-details {
    display: flex;
    flex-direction: column;
}

.payment-name {
    font-weight: 600;
    font-size: 1rem;
}

.payment-value {
    font-size: 0.9rem;
    color: #666;
}

.payment-actions {
    display: flex;
    gap: 0.5rem;
}

.btn-sm {
    padding: 0.375rem 0.75rem;
    font-size: 0.85rem;
    border-radius: 0.4rem;
}

.payment-setting-btn {
    border: unset;
    /* color: #e3bd3e; */
    color: #64748f;
    font-family: 'Manrope-Bold';
    font-size: medium;
}

.payment-setting-btn:focus {
    border: unset;
    outline: unset;
    box-shadow: unset;
}

.default .payment-setting-btn {
    color: #e3bd3e;
}

.select2-container {
    z-index: 9999 !important;

}

.payoutSettingModal .cus-err {
    position: relative;
}

.payoutSettingModal .iti,
.payoutSettingModal .iti--allow-dropdown {
    margin-bottom: unset;
}

.productImportLabel {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #334155 !important;
    font-family: 'Manrope-SemiBold'
}

.tour-label {
    display: flex;
    align-items: center;
}

.dot {
    height: 6px;
    width: 6px;
    background-color: #94A3B8;
    /* Tailwind's gray-400 */
    border-radius: 50%;
    margin: 0 10px;
}

.customBtnRed {
    background: #ad0707;
    width: 300px;
    font-family: 'Manrope-Bold';
    border-radius: 30px;
    min-height: 45px;
    color: white;
    outline: unset;
    border: unset;
}

.rightProfile .rightProfileMain .iti--inline-dropdown .iti__country-list .iti__country {
    display: flex !important;
    padding: 8px !important;
}

.rightProfile .rightProfileMain .iti--inline-dropdown .iti__country-list .iti__country span {
    font-size: 16px !important;
}

.listloader {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    background:
        radial-gradient(farthest-side, #E3BD3E 94%, #0000) top/8px 8px no-repeat,
        conic-gradient(#0000 30%, #E3BD3E);
    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
    animation: l13 1s infinite linear;
}

@keyframes l13 {
    100% {
        transform: rotate(1turn)
    }
}


.actThemeMain .list-loader-container {
    margin-top: 10px !important;
    justify-content: unset !important;
}

.actThemeMain .listloader {
    width: 30px !important;
}

.cke_notification_warning {
    display: none !important;
}

body.dark .notfoundLabel {
    background-color: #2c2c2c !important;
}

body.dark .dark_common_modal .modal-body,
body.dark .dark_common_modal .modal-content {
    background-color: var(--dark-box) !important;
}

body.dark .dark_common_modal .modal-header .modal-title,
body.dark .dark_common_modal label {
    color: #CBD5E1;
}

body.dark .profileImport .userPersonaldet .toptitle h5 {
    color: #94A3B8 !important;
    border-color: #475569;
}

body.dark .css-t3ipsp-control,
body.dark .css-13cymwt-control,
body.dark .css-1nmdiq5-menu {
    background-color: #2c2c2c;
    color: #CBD5E1;
}

body.dark .dark_common_modal .modal-body .card .card-body {
    background-color: #171202 !important;
    color: #CBD5E1;

}

body.dark .dark_common_modal .modal-body .card {
    border: unset;
}

body.dark .dark_common_modal .modal-body .card .boxCard input {
    background-color: #171202;
    color: #CBD5E1;
}

body.dark .commonFileInputSecond {
    background-color: var(--body-box) !important;
    border-color: #334155 !important;
}

body.dark .btn-close {
    filter: invert(1);
}

body.dark .permission_modal th,
body.dark .permission_modal b {
    color: #CBD5E1;

}

body.dark .commonGoldBtn {
    color: var(--dark-box);
}

body.dark .detasilTitle .detasilBox ul li a i,
body.dark .subimageBox .dragBox .btnDrag {
    color: #94A3B8 !important;
}

body.dark .detasilTitle .detasilBox ul li a,
body.dark .subimageBox .dragBox .btnDrag {
    background-color: #171202;
}

body.dark .tourListbox span.listgray {
    background-color: #F5A524 !important;
}

body.dark .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
    background-color: #171202;

}

body.dark .select2-search__field {
    background-color: #171202;
    color: #CBD5E1;
}

body.dark .mainTableBox table thead tr th {
    background-color: #b1b5c3;
}

.real-exp-map-search {
    width: 40%;
    position: absolute;
    right: 70px;
    top: 11px;
    z-index: 2;
}

.suggetionContainerThemes.suggestUp ul li a {
    background-color: #f4e6f9 !important;
    color: #7b3f7b !important;
}

.suggetionContainerThemes.suggestUp ul li a i {
    color: #7b3f7b !important;

}

#tags-tabs,
#desc-lang-tabs {
    padding: 0 !important;
    border-bottom: 2px solid #e0c97a !important;
    gap: 4px;
    flex-wrap: wrap;
}

#tags-tabs .nav-link,
#desc-lang-tabs .nav-link {
    color: #6c757d;
    font-weight: 500;
    font-size: 14px;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    transition: color 0.2s, background 0.2s;
    background: transparent;
}

#tags-tabs .nav-link:hover,
#desc-lang-tabs .nav-link:hover {
    color: #BB8E11;
    background: #fdf8ec;
    border-color: #e0c97a #e0c97a transparent;
}

#tags-tabs .nav-link.active,
#desc-lang-tabs .nav-link.active {
    color: #BB8E11 !important;
    background: #fff !important;
    border-color: #e0c97a #e0c97a #fff !important;
    font-weight: 600;
}

#tags-tabs.nav,
#desc-lang-tabs.nav {
    border-radius: unset !important;
}

.desc-lang-tab-pane {
    border: 1px solid #e0c97a;
    border-top: none;
    padding: 12px;
    border-radius: 0 0 6px 6px;
    background: #fff;
}

.sitting_option {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    text-align: center;
    padding-top: 20px;
}

/* Dashboard welcome hero (redesigned) */
.welcome-hero {
    padding: 8px 0 0;
}
.welcome-eyebrow {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 16px;
}
.welcome-eyebrow-line {
    height: 2px;
    width: 70px;
    max-width: 12vw;
    border-radius: 2px;
    background: linear-gradient(90deg, transparent, var(--gold-color));
}
.welcome-eyebrow-line:last-child {
    background: linear-gradient(90deg, var(--gold-color), transparent);
}
.welcome-eyebrow-text {
    color: var(--gold-color);
    font-family: 'Manrope-Bold';
    font-size: 18px;
    white-space: nowrap;
}
.welcome-eyebrow.work-with .welcome-eyebrow-text {
    color: #23252E;
}
.welcome-title {
    font-family: 'Manrope-Bold';
    font-size: 48px;
    line-height: 1.12;
    color: #10131a;
    margin: 0 auto 20px;
    max-width: 900px;
}
.welcome-title .gold {
    color: var(--gold-color);
}
.welcome-subtitle {
    max-width: 640px;
    margin: 0 auto 34px;
    color: #6b7280;
    font-size: 17px;
    line-height: 1.6;
}

/* Provider logo cards (Dashboard welcome hero only) */
.welcome-hero .sitting_option {
    grid-template-columns: repeat(5, 1fr);
}
.welcome-hero .sitting_option .box_box {
    background: #ffffff;
    border: 1px solid #eef0f4;
    border-radius: 16px;
    padding: 22px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 18px rgba(17, 24, 39, 0.05);
    transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.welcome-hero .sitting_option .box_box:hover {
    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.10);
    transform: translateY(-3px);
}
.welcome-hero .sitting_option .box_box a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}
.turitop_bg {
    background-color: #f4f6f8;
}

@media (max-width: 1199px) {
    .welcome-title {
        font-size: 40px;
    }
}
@media (max-width: 991px) {
    .welcome-hero .sitting_option {
        grid-template-columns: repeat(3, 1fr);
    }
    .welcome-title {
        font-size: 34px;
    }
    .welcome-subtitle {
        font-size: 15px;
    }
}
@media (max-width: 575px) {
    .welcome-hero .sitting_option {
        grid-template-columns: repeat(2, 1fr);
        gap: 14px;
    }
    .welcome-title {
        font-size: 27px;
    }
    .welcome-eyebrow-text {
        font-size: 15px;
    }
    .welcome-eyebrow-line {
        width: 34px;
    }
}

.sitting_option .box_box svg {
    width: 60px;
    height: 60px;
    color: #515760;
    transition: 0.3s all;
}

.sitting_option .box_box img {
    width: 90px;
}

.sitting_option .box_box a:hover svg {
    color: var(--gold-color);
}

.sitting_option .box_box h6 {
    color: #23262F;
    font-family: 'Manrope-Bold';
}

.path.blue_modal {
    fill: #006FEE !important;
}

.com_bgbox {
    height: 80px;
    width: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 30px;
    border-radius: 10px;
    position: relative;
}

.com_bgbox .pending_tag {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: var(--gold-color);
    padding: 1px 7px;
    border-radius: 30px;
    font-size: 10px;
    color: var(--text-black);
    display: none;
}

.com_bgbox.view_pending .pending_tag {
    display: block;
}

.sitting_option .box_box .com_bgbox svg {
    width: 90px;
    height: 90px;
}

.bokun_bg {
    background-color: #000000;
}

.fareHarbor_bg {
    background-color: rgb(198 227 255);
}

.prularo_bg {
    background-image: linear-gradient(204deg, #161C27 25%, #f2295b 100%);
}

.rezdy_bg {
    background-color: #e5ecfa;
}

.icon-logo .svg-ticket-bg,
.icon-logo-ticket .svg-ticket-bg {
    fill: #0a6ece;
}

.icon-logo .svg-ticket-detail,
.icon-logo-ticket .svg-ticket-detail {
    fill: #fff;
}

.icon-logo .svg-text,
.icon-logo-text .svg-text,
.icon-logo-circle-with-text .svg-text {
    fill: #0a6ece;
}

.icon-logo .svg-ticket-stroke,
.icon-logo-ticket .svg-ticket-stroke {
    fill: #0a6ece;
    visibility: hidden;
}

.iti--inline-dropdown .iti__dropdown-content {
    z-index: 99999 !important;
}

.step_instruction .step_viewer:not(:last-child) {
    margin-bottom: 60px;
}

.step_instruction .first_box h5 {
    color: #23262F;
    font-family: 'Manrope-Bold';
}

.step_instruction .step_viewer h6 {
    margin-bottom: 20px;
    font-family: 'Manrope-Medium';
    font-size: 16px;
}

.step_instruction .step_viewer h6 strong {
    font-weight: 900 !important;
}

.step_instruction .step_viewer h6 a {
    text-decoration: underline;
    color: #6c5508;
}

.step_instruction .step_viewer img {
    margin-top: 10px;
}

.step_instruction .step_viewer ul {
    list-style: disc;
}

.step_instruction .step_viewer ul {
    list-style: unset !important;
    padding-left: 20px;
}

.step_instruction .step_viewer ul li {
    list-style: disc;
    display: list-item;
    margin-bottom: 10px !important;
    width: 100% !important;
}

.step_instruction .step_viewer ul li p {
    color: #23262F;
    font-family: 'Manrope-Medium';
}

.step_instruction .step_viewer .url_copy {
    display: flex;
    justify-content: space-between;
    background-color: #F9F3DC;
    border-radius: 10px;
    padding: 10px 20px;
}

.step_instruction .step_viewer .url_copy p {
    margin-bottom: 0;
    font-size: 14px;
    color: #23262F;
    font-family: 'Manrope-Medium';
}

.step_instruction .step_viewer .url_copy .btn_copy {
    padding: 0;
    border: none;
    box-shadow: none;
}

.step_instruction .step_viewer .url_copy .btn_copy i {
    margin-right: 5px;
    vertical-align: middle;
}


.loading-container {
    /* Full screen setup */
    min-height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;

    /* Trendy Background (Use a solid color or subtle background texture if allowed) */
    background-color: #f7f9fc;
    /* Very light background color */
    /* font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; */
    color: #333333;
    -webkit-font-smoothing: antialiased;
    padding: 20px;
    box-sizing: border-box;
}

/* Auth Card - The Focus Element */
.auth-card {
    /* Glassmorphism/Neumorphism Inspired Look */
    background: rgba(255, 255, 255, 0.9);
    /* Semi-transparent white */
    backdrop-filter: blur(8px);
    /* Trendy blur effect (if supported) */
    padding: 50px 40px;
    border-radius: 16px;
    /* Smoother, modern corners */
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.03);
    /* Soft, multi-layer shadow */
    text-align: center;
    max-width: 500px;
    width: 100%;
    transition: transform 0.3s ease;
    font-family: 'Manrope-Regular';

}

/* Typography */
.auth-card h1 {
    font-size: 28px;
    /* Larger, bolder heading */
    /* font-weight: 700; */
    margin-top: 15px;
    margin-bottom: 20px;
    color: #1a1a1a;
    line-height: 1.2;
    font-family: 'Manrope-Bold';
}

.auth-card p {
    font-size: 15px;
    color: #555555;
    margin: 8px 0;
}

.small-text {
    font-size: 13px;
    margin-top: 25px;
    color: #999999;
    font-style: italic;
}

/* Branded Spinner */
.spinner {
    display: inline-block;
    width: 60px;
    height: 60px;
    position: relative;
    /* margin-bottom: 20px; */
}

.spinner:before {
    content: '';
    box-sizing: border-box;
    display: block;
    width: 100%;
    height: 100%;
    border: 4px solid rgba(0, 0, 0, 0.1);
    /* Change this color to your brand's primary color, e.g., a blue or green */
    border-top-color: var(--gold-color);
    border-radius: 50%;
    animation: spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    /* Smoother animation curve */
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/*  */
/* Page Wrapper */
.providers-page {
    max-width: 1100px;
    margin: 0 auto;
    padding: 24px;
}

.providers-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
}

/* Provider Card */
.provider-card {
    border-radius: 14px;
    margin-bottom: 18px;
    border: none;
    /* box-shadow: 0 8px 22px rgba(0, 0, 0, 0.06); */
    overflow: hidden;
}

/* Accordion Header */
.provider-card .accordion-button {
    background-color: #f8fafc;
    padding: 18px 22px;
}

.provider-card .accordion-button:not(.collapsed) {
    /* background-color: #eef4ff; */
    color: #000;
}

.provider-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.provider-name {
    font-size: 16px;
    font-weight: 600;
}

.provider-badge {
    font-size: 12px;
    padding: 4px 8px;
}

/* Body */
.provider-body {
    padding: 24px;
}

/* Logo */
/* .provider-logo {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
} */

/*  */
.hero-section {
    padding: 20px;
    /* background: linear-gradient(to bottom, #f3ead2, #ffffff); */
    text-align: center;
    font-family: 'Manrope-Regular';
}

.hero-section>h2 {
    font-size: 1.8rem;
    color: #333;
    font-family: 'Manrope-Regular';
}

.hero-title {
    font-size: 3rem;
    font-weight: 800;
    color: #1e1e1e;
    line-height: 1.2;
    font-family: 'Manrope-Bold';
}

.highlight {
    color: #e3bd3e;
    /* your theme */
}

.hero-subtitle {
    margin-top: 18px;
    font-size: 1.15rem;
    color: #555;
}

.hero-btn {
    margin-top: 35px;
    background: #e3bd3e;
    color: #fff;
    border-radius: 40px;
    padding: 14px 34px;
    font-size: 1.1rem;
    font-weight: 600;
    border: none;
    transition: 0.3s;
}

.hero-btn:hover {
    background: #c5a132;
}

/* =========================================================
   Dashboard "Visibility" hero (v2)
   ========================================================= */
.hero-section-v2 {
    position: relative;
    overflow: hidden;
    padding: 50px 24px 44px;
    border-radius: 24px;
    background:
        radial-gradient(circle at 12% 16%, rgba(227, 189, 62, 0.10), transparent 42%),
        radial-gradient(circle at 88% 6%, rgba(227, 189, 62, 0.08), transparent 40%);
}
.hero-section-v2 > * {
    position: relative;
    z-index: 1;
}
.hero-blob {
    position: absolute;
    border-radius: 50%;
    background: rgba(227, 189, 62, 0.12);
    z-index: 0;
    pointer-events: none;
}
.hero-blob-1 {
    width: 240px;
    height: 240px;
    top: -70px;
    left: -80px;
}
.hero-blob-2 {
    width: 150px;
    height: 150px;
    bottom: -55px;
    left: 7%;
    background: rgba(227, 189, 62, 0.08);
}
.hero-dots {
    position: absolute;
    top: 40px;
    right: 44px;
    width: 92px;
    height: 60px;
    background-image: radial-gradient(rgba(227, 189, 62, 0.45) 1.5px, transparent 1.6px);
    background-size: 12px 12px;
    opacity: 0.5;
    z-index: 0;
    pointer-events: none;
}

/* Pill badge */
.hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 24px;
    background: #ffffff;
    border: 1px solid #f2e6bf;
    border-radius: 40px;
    box-shadow: 0 6px 18px rgba(227, 189, 62, 0.12);
    color: #1b2333;
    font-family: 'Manrope-Bold';
    font-size: 16px;
    margin-bottom: 26px;
}
.hero-badge svg {
    color: var(--gold-color);
    flex: 0 0 auto;
}

/* Title with gold swoosh underline */
.hero-section-v2 .hero-title {
    font-size: 3.4rem;
    line-height: 1.12;
    color: #101828;
    max-width: 900px;
    margin: 0 auto 22px;
}
.hero-section-v2 .highlight {
    position: relative;
    color: var(--gold-color);
    white-space: nowrap;
}
.hero-section-v2 .highlight::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -12px;
    height: 12px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
}

.hero-section-v2 .hero-subtitle {
    max-width: 790px;
    margin: 0 auto 36px;
    font-size: 1.05rem;
    line-height: 1.7;
    color: #4b5563;
    text-align: center;
}

/* Feature row */
.hero-features {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    margin: 0 auto 38px;
    max-width: 920px;
}
.hero-feature {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 16px;
    text-align: left;
}
.hero-feature:not(:last-child) {
    border-right: 1px solid #eadfbf;
}
.hero-feature-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(227, 189, 62, 0.14);
    color: var(--gold-color);
    flex: 0 0 auto;
}
.hero-feature p {
    margin: 0;
    font-family: 'Manrope-Bold';
    font-size: 15px;
    color: #1b2333;
    line-height: 1.25;
    max-width: 92px;
    white-space: normal;
}

/* CTA with spark decorations */
.hero-cta-wrap {
    position: relative;
    display: inline-block;
}
.hero-cta-wrap::before,
.hero-cta-wrap::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 24px;
    height: 32px;
    transform: translateY(-50%);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / contain;
}
.hero-cta-wrap::before {
    left: -36px;
}
.hero-cta-wrap::after {
    right: -36px;
    transform: translateY(-50%) scaleX(-1);
}

.hero-section-v2 .hero-btn {
    margin-top: 0;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(180deg, #e8c65a 0%, #d9ab2f 100%);
    color: #1b2333;
    font-family: 'Manrope-Bold';
    padding: 15px 42px;
    font-size: 1.05rem;
    box-shadow: 0 10px 24px rgba(217, 171, 47, 0.35);
}
.hero-section-v2 .hero-btn:hover {
    background: linear-gradient(180deg, #e2bd45 0%, #c9992a 100%);
}
.hero-btn-arrow {
    font-size: 1.2rem;
    line-height: 1;
}

@media (max-width: 991px) {
    .hero-section-v2 .hero-title {
        font-size: 2.4rem;
    }
    .hero-badge {
        font-size: 14px;
    }
}
@media (max-width: 767px) {
    .hero-section-v2 {
        padding: 36px 16px 32px;
    }
    .hero-section-v2 .hero-title {
        font-size: 1.9rem;
    }
    .hero-features {
        flex-wrap: wrap;
        gap: 8px;
    }
    .hero-feature {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc(50% - 4px);
        padding: 10px 12px;
        justify-content: flex-start;
    }
    .hero-feature p {
        max-width: none;
    }
    .hero-feature:not(:last-child) {
        border-right: none;
    }
    .hero-feature p {
        font-size: 14px;
    }
    .hero-badge span {
        text-align: left;
    }
}
@media (max-width: 420px) {
    .hero-feature {
        flex: 0 0 100%;
    }
}


.pricing-card {
    font-family: 'Manrope-Regular';
    /* border: 2px solid #d4b463; */
    border-radius: 20px;
    padding: 2rem;
    text-align: center;
    background-color: white;
    transition: all 0.3s ease;
    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); */
}

.pricing-card:hover {
    /* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12); */
}

.pricing-price {
    font-size: 2.4rem;
    font-weight: 600;
    color: #1a1a1a;
    font-family: 'Manrope-Bold';
}

.pricing-price > h6 {
    font-family: 'Manrope-Regular';
    margin-bottom: 0;
}

.pricing-credits {
    font-size: 2.4rem;
    display: flex;
    justify-content: center;
    font-weight: 500;
    margin-bottom: 0.5rem;
    gap: 7px;
    color: #00000061;
    font-family: 'Manrope-Bold';
}

.pricing-credits-amount {
    font-family: 'Manrope-Regular';
    font-size: 2rem;
}

.pricing-credits-value {
    text-align: left;
    font-size: 0.9rem;
}

.page-heading {
    font-family: 'Manrope-Bold';
}

.pricing-title {
    color: var(--google-blue);
    font-size: 26px;
    font-weight: 600;
}

.pricing-card small.sup {
    font-size: 14px;
    vertical-align: super;
}

.pricing-btn {
    color: #fff;
    background-color: #e3bd3e;;
    border-radius: 40px;
    padding: 12px 30px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: 0.3s;
    font-size: 1rem;
}

.pricing-btn:hover {
    background: #c5a132;
    color: #fff;
}

/* Payment css */
.titlebox {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    margin-bottom: 30px;
    font-family: 'Manrope-Regular';
}

.titlebox > h4{
    color: #23252E;
    font-family: 'Gilroy-Bold';
    margin-bottom: 0;
}

.titlebox > span{
    padding: 5px 15px;
    border-radius: 30px;
    background-color: #F0FDF4 !important;
    font-size: 20px;
    font-family: 'Manrope-Bold';
    color: #24D164;
}

.nav-justified .nav-item,
.nav-justified>.nav-link {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center;
}

.confirm_left .tab-pane .checkAndGo:not(:last-child) {
    margin-bottom: 10px;
}

.tandcMainDiv {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.tandcLink {
    color: #ECBB33 !important;
    text-decoration: underline;
    font-size: 16px;
    font-family: 'Manrope-Medium';
}

.confirm_left .tab-pane .checkAndGo .clickTo .keyword-label {
    font-size: 16px;
    color: #171202;
    font-family: 'Manrope-Medium';
}

.confirm_left .tab-pane .registerBox .form-group.cradImg {
    position: relative;
}

.registerBox .form-group label {
    color: #292929;
    font-size: 14px;
    font-family: 'Manrope-Medium';
    padding-bottom: 10px;
}

.stripe-custom-form .commonInputSecond {
    padding: 13px !important;
}

.confirm_left .paymentTab {
    margin-bottom: 30px;
}

.confirm_left .paymentTab .nav-tabs {
    border-bottom: none;
    gap: 10px;
    margin-bottom: 30px;
    overflow-y: hidden;
    overflow-x: auto;
    flex-wrap: nowrap;
    scrollbar-width: none;
}

.confirm_left .paymentTab .nav-tabs .nav-link img.white {
    display: none;
}

.confirm_left .paymentTab .nav-tabs .nav-link.active img.white {
    display: block;
}

.confirm_left .paymentTab .nav-tabs .nav-link.active img.black {
    display: none;
}

.confirm_left .paymentTab .nav-tabs .nav-link {
    color: #5D4709;
    font-size: 14px;
    font-family: 'Manrope-Bold';
    border: 1px solid #FDF7E8;
    border-radius: 6px;
    background-color: #FFFFFF;
    min-height: 40px;
    box-shadow: 0 0.62px 6.5px #B7B7B714;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.provider-logo svg {
    max-width: 120px;
    max-height: 50px;
}

/* Connected State */
.provider-connected {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
}

.provider-label {
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 4px;
}

.provider-value {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 6px;
}

.provider-success {
    font-size: 13px;
    color: #16a34a;
}

/* Connect State */
.provider-connect {
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px
}

.provider-input {
    /* margin-bottom: 14px; */
    padding: 10px 14px;
    border-radius: 8px;
}

/* Buttons */
.provider-btn {
    border-radius: 8px;
    padding: 8px 18px;
    font-weight: 500;
}
.bokunDropBox .disabled{
    pointer-events: none;
    opacity: 0.6;
}

/* Mobile header menu - user info block */
.mobileUserInfo {
    padding: 4px 0 12px;
    margin-bottom: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.mobileUserInfo h6 {
    margin: 0 0 2px;
    font-size: 16px;
    font-weight: 700;
    color: inherit;
}
.mobileUserInfo p {
    margin: 0;
    font-size: 13px;
    opacity: 0.7;
}

/* =========================================================
   Providers page - redesigned cards (v2)
   ========================================================= */
.providers-grid-v2 {
    display: flex;
    flex-direction: column;
    gap: 22px;
    font-family: 'Manrope-Regular', sans-serif;
}

/* Per-provider accent colors (drive accent bar, badge, button, gradient) */
.provider-card-v2 {
    --accent: #22c55e;
    --accent-soft: rgba(34, 197, 94, 0.10);
    --media-from: #f0fdf4;
    --media-to: #ffffff;
}
.provider-card-v2.provider-fareharbor {
    --accent: #0a6ece;
    --accent-soft: rgba(10, 110, 206, 0.10);
    --media-from: #eff6ff;
    --media-to: #ffffff;
}
.provider-card-v2.provider-pluralo {
    --accent: #e73e46;
    --accent-soft: rgba(231, 62, 70, 0.10);
    --media-from: #fef2f2;
    --media-to: #ffffff;
}
.provider-card-v2.provider-turitop {
    --accent: #2aa3a8;
    --accent-soft: rgba(42, 163, 168, 0.10);
    --media-from: #eefcfb;
    --media-to: #ffffff;
}

.provider-card-v2 {
    position: relative;
    display: flex;
    align-items: stretch;
    background: #ffffff;
    border: 1px solid #eef0f4;
    border-radius: 16px;
    overflow: hidden;
}

/* Left accent bar */
.provider-card-v2::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: var(--accent);
    z-index: 2;
}

/* Media / logo zone with soft gradient */
.provider-media {
    position: relative;
    flex: 0 0 240px;
    max-width: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 28px 24px;
    background: linear-gradient(135deg, var(--media-from) 0%, var(--media-to) 100%);
    border-right: 1px solid #f1f2f6;
}

.provider-logo-v2 {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 10px;
}
.provider-logo-v2 svg {
    max-width: 140px;
    /* max-height: 48px; */
    height: auto;
}
.provider-logo-v2 img {
    max-width: 120px;
    height: auto;
}
.provider-bokun-logo {
    max-width: 100px !important;
}
.provider-turitop-logo {
    max-width: 130px !important;
}

/* Pluralo + Octo stacked logos */
.provider-logo-stack {
    flex-direction: column;
    gap: 14px;
}
.provider-plus {
    font-size: 20px;
    font-weight: 700;
    color: #1f2937;
}

/* Decorative dotted pattern in the media zone */
.provider-dots {
    position: absolute;
    bottom: 14px;
    left: 18px;
    width: 60px;
    height: 34px;
    background-image: radial-gradient(var(--accent) 1.4px, transparent 1.6px);
    background-size: 10px 10px;
    opacity: 0.35;
    z-index: 0;
}

/* Right content area */
.provider-content {
    flex: 1 1 auto;
    display: flex;
    align-items: end;
    gap: 24px;
    padding: 22px 26px;
    min-width: 0;
}

.provider-content-main {
    flex: 1 1 40%;
    min-width: 0;
}
.provider-title-v2 {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 12px;
    font-family: 'Manrope-Bold', sans-serif;
}

.provider-detail-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}
.provider-detail-row + .provider-detail-row {
    margin-top: 12px;
}
.provider-detail-icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #f3f4f6;
    color: #6b7280;
}
.provider-detail-label {
    font-size: 13px;
    color: #9ca3af;
    margin: 0 0 2px;
}

/* Integration key label + eye toggle */
.provider-key-label-row {
    display: flex;
    align-items: center;
    gap: 8px;
}
.provider-eye-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #f9fafb;
    color: #6b7280;
    cursor: pointer;
    transition: color 0.2s ease, border-color 0.2s ease;
}
.provider-eye-btn:hover {
    color: var(--accent);
    border-color: var(--accent);
}
.provider-detail-value {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    word-break: break-word;
}

/* Status column with vertical divider */
.provider-content-status {
    flex: 1 1 34%;
    min-width: 0;
    padding-left: 24px;
    border-left: 1px solid #eef0f4;
    min-height: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.provider-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 15px;
    font-weight: 600;
    color: var(--accent);
    margin-bottom: 6px;
}
.provider-check-icon {
    color: var(--accent);
}
.provider-status-text {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
    line-height: 1.45;
}

/* Action column */
.provider-content-action {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
}

.provider-btn-v2 {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 11px 22px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    border: 1.5px solid var(--accent);
    background: transparent;
    color: var(--accent);
    white-space: nowrap;
    transition: background 0.2s ease, color 0.2s ease;
}
.provider-btn-v2:hover,
.provider-btn-v2:focus,
.provider-btn-v2:active {
    background: var(--accent) !important;
    border-color: var(--accent) !important;
    color: #ffffff !important;
    box-shadow: none !important;
}
.provider-btn-v2 svg {
    width: 18px;
    height: 18px;
}

/* Disconnected state: inputs stacked in the main column */
.provider-connect-fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
}
.provider-connect-fields .provider-input {
    padding: 11px 14px;
    border-radius: 9px;
    border: 1px solid #e5e7eb;
}
.provider-card-v2.is-disconnected .provider-content-status {
    border-left: none;
    padding-left: 0;
    flex: 0 0 auto;
}

/* Responsive */
@media (max-width: 991px) {
    .provider-card-v2 {
        flex-direction: column;
    }
    .provider-media {
        flex: 0 0 auto;
        max-width: none;
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #f1f2f6;
    }
    .provider-content {
        flex-wrap: wrap;
        gap: 18px;
    }
    .provider-content-main,
    .provider-content-status {
        flex: 1 1 100%;
    }
    .provider-content-status {
        border-left: none;
        padding-left: 0;
    }
    .provider-content-action {
        flex: 1 1 100%;
    }
    .provider-content-action .provider-btn-v2 {
        width: 100%;
        justify-content: center;
    }
}
.provider-card .accordion-header .accordion-button:focus {
    box-shadow: unset !important;
}
.provider-card .accordion-header .accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.confirm_left .paymentTab .nav-tabs .nav-link svg {
    margin-right: 5px;
    vertical-align: middle;
}

.confirm_left .paymentTab .nav-tabs .nav-link.active {
    color: #fff;
    background-color: #2F2304;
    border-color: #2F2304;
}

.confirm_left .paymentTab .nav-tabs .nav-link.active svg>path {
    fill: #fff;
}

.confirm_left .tab-pane .registerBox .box-box {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.confirm_left .tab-pane .registerBox .box-box .form-group {
    width: calc(50%);
}

.confirm_left .tab-pane .registerBox .form-group.cradImg {
    position: relative;
}

.confirm_left .tab-pane .registerBox .form-group.cradImg img {
    position: absolute;
    top: 65%;
    right: 10px;
    transform: translateY(-30%);
    border: 1px solid #D9D9D9;
    padding: 2px;
    border-radius: 2.5px;
    width: 100%;
    max-width: 35px;
}

.confirm_left .tab-pane .registerBox .box-box .form-group input::placeholder {
    color: #BDBDBD;
    font-size: 14px;
    font-family: 'Manrope-Medium';
}

.confirm_left .tab-pane .checkAndGo:not(:last-child) {
    margin-bottom: 10px;
}

.confirm_left .tab-pane .checkAndGo .clickTo {
    position: relative;
    padding-left: 28px;
    margin-bottom: 5px;
}

.confirm_left .tab-pane .checkAndGo .clickTo .keyword-label {
    font-size: 16px;
    color: #171202;
    font-family: 'Manrope-Medium';
}

.confirm_left .tab-pane .checkAndGo .clickTo .keyword-label a {
    color: #ECBB33;
    text-decoration: underline;
}

.confirm_left .tab-pane .checkAndGo p {
    font-size: 16px;
    color: #171202;
    font-family: 'Manrope-Medium';
}

.confirm_left .tab-pane .checkAndGo p a {
    color: #ECBB33;
    text-decoration: underline;
}

.confirm_left .tab-pane .checkAndGo .clickTo input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    margin-right: 0px;
    left: 0;
    top: 0;
    height: 18px;
    width: 18px;
    border-radius: 4px;
    z-index: 55;
    cursor: pointer;
}

.confirm_left .tab-pane .checkAndGo .clickTo input[type="checkbox"]+.keyword-label::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    cursor: pointer;
    height: 18px;
    border: 2px solid #CBD5E1;
    background-color: #fff;
    border-radius: 5px;
}

.confirm_left .tab-pane .checkAndGo .clickTo input[type="checkbox"]:checked+.keyword-label::after {
    content: '\\f00c';
    position: absolute;
    font-family: 'fontawesome';
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #fff;
    background-color: var(--gold-color);
    width: 18px;
    height: 18px;
    text-align: center;
    border-radius: 4px;
    padding-top: 1px;
}

.stripe-custom-form .card-branding {
    border: unset !important;
}

.confirm_left .registerBox .onlyText p {
    color: #475569;
    font-size: 14px;
}

.titleWithLinks{
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.ads-status .form-check-input:not(:checked):focus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
}

/*  */

.payment-container {
    /* background: rgba(255, 255, 255, 0.95); */
    padding: 0px 40px;
    width: 420px;
    text-align: center;
    border-radius: 16px;
    /* box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.12); */
    position: relative;
    backdrop-filter: blur(10px);
}

.payment-icon {
    width: 80px;
    height: 80px;
    background: #e3bd3e;
    color: white;
    font-size: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto;
    box-shadow: 0px 5px 15px rgba(227, 189, 62, 0.3);
}

.processing-title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #23262F;
    font-family: 'Manrope-SemiBold';
}

.processing-loading-text {
    font-size: 16px;
    font-weight: 700;
    color: #94A3B8;
    font-family: 'Manrope-Regular';
}

.processing-expire-note {
    font-size: 16px;
    font-weight: 600;
    color: #475569;
    font-family: 'Manrope-Regular';
}

.cancelRedBtn {
    background-color: #e53935;
    /* Bright red */
    color: #fff;
    /* White text */
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.cancelRedBtn:hover {
    background-color: #c62828;
    /* Darker red on hover */
}

/*  */
.alertMessage {
    background-color: #e3bd3e;
    color: #c62828;
    margin: 0;
    padding: 10px;
    border-radius: 20px;
}

.disabled-btn {
    opacity: 50%;
    cursor: not-allowed;
}

.sectionTitle {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 16px;
}

.sectionTitle:not(:first-of-type) {
    margin-top: 16px;
}

.show_visitor {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 8px;
}

.show_visitor .comBgGray {
    background-color: #f6f6f6;
    padding: 1px 6px;
    border-radius: 5px;
    border: 1px solid #dcdee0;
    min-height: 28px;
    vertical-align: middle;
}

.show_visitor .comBgGray i {
    font-size: 14px;
    margin-right: 4px;
}

.listText .book_count {
    font-size: 14px;
    color: #23262F;
    font-family: 'Manrope-Bold';
}

.rightTabcontent .listBoxproduct .listEditBox .btnGold {
    background-color: var(--gold-color);
    color: var(--text-black) !important;
    margin-top: 20px;

}

/* ==========================================================================
   Footer redesign (shared by logged-out DefaultLayout & logged-in DashboardLayout)
   Markup: src/components/Footer.jsx  |  overrides base public/assest/css/style.css
   ========================================================================== */

.txFooter .footerBox {
    max-width: 1200px;
    margin: 0 auto;
}

/* --- Top grid: Brand | Support | Need Help | Stay Connected --- */
.txFooter .txFooterGrid {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1.3fr 1.2fr;
    gap: 40px;
    padding-bottom: 40px;
}

.txFooter .txFooterGrid h4 {
    color: var(--gold-color, #ecbb33);
    font-family: 'Gilory-SemiBold', sans-serif;
    font-size: 13px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 22px;
}

/* --- Brand column --- */
.txFooter .txFooterLogo {
    display: inline-block;
    margin-bottom: 20px;
}

.txFooter .txFooterBrand .txFooterLogo img {
    max-width: 190px;
    width: 100%;
}

.txFooter .txFooterBrand p {
    color: #888e9d;
    font-family: 'Poppins-Regular', sans-serif;
    font-size: 13px;
    line-height: 1.7;
    max-width: 280px;
    margin: 0;
}

/* --- Support links column --- */
.txFooter .txFooterSupport ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.txFooter .txFooterSupport ul li {
    margin-bottom: 12px;
}

.txFooter .txFooterSupport ul li a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: #c7ccd6;
    font-family: 'Gilory-SemiBold', sans-serif;
    font-size: 14px;
    text-decoration: none;
    transition: color 0.2s ease, transform 0.2s ease;
}

.txFooter .txFooterSupport ul li a i {
    font-size: 12px;
    color: #6b7280;
    transition: color 0.2s ease, transform 0.2s ease;
}

.txFooter .txFooterSupport ul li a:hover {
    color: var(--gold-color, #ecbb33);
}

.txFooter .txFooterSupport ul li a:hover i {
    color: var(--gold-color, #ecbb33);
    transform: translateX(3px);
}

/* --- Need Help card --- */
.txFooter .txHelpCard {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 22px 24px;
    border: 1px solid #f1f4f729;
    border-radius: 16px;
    text-decoration: none;
    background: rgba(255, 255, 255, 0.02);
    transition: border-color 0.2s ease, background 0.2s ease;
}

.txFooter .txHelpCard:hover {
    border-color: var(--gold-color, #ecbb33);
    background: rgba(236, 187, 51, 0.06);
}

.txFooter .txHelpIcon {
    flex: 0 0 auto;
    height: 48px;
    width: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(236, 187, 51, 0.12);
    color: var(--gold-color, #ecbb33);
    font-size: 20px;
}

.txFooter .txHelpBody {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.txFooter .txHelpTitle {
    color: var(--white-color, #fff);
    font-family: 'Gilory-SemiBold', sans-serif;
    font-size: 17px;
}

.txFooter .txHelpDesc {
    color: #888e9d;
    font-family: 'Poppins-Regular', sans-serif;
    font-size: 13px;
}

.txFooter .txHelpLink {
    color: var(--gold-color, #ecbb33);
    font-family: 'Gilory-SemiBold', sans-serif;
    font-size: 13px;
    margin-top: 2px;
}

/* --- Stay Connected column --- */
.txFooter .txSocial {
    list-style: none;
    padding: 0;
    margin: 0 0 28px 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
}

.txFooter .txSocial li {
    flex: 0 0 auto;
}

.txFooter .txSocial li a {
    height: 36px;
    width: 36px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f1f4f729;
    color: var(--white-color, #fff);
    font-size: 15px;
    text-decoration: none;
    transition: background-color 0.2s ease, color 0.2s ease;
}

.txFooter .txSocial li a:hover {
    background-color: var(--gold-color, #ecbb33);
    color: var(--text-black, #14181f);
}

.txFooter .txSocial li a svg {
    width: 16px;
    height: 16px;
}

.txFooter .txPayment {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 12px;
    row-gap: 10px;
}

.txFooter .txPayment li span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 44px;
    padding: 4px 6px;
    border-radius: 6px;
    background-color: var(--white-color, #fff);
    border: 1px solid #e2e6ee;
}

.txFooter .txPayment li span img {
    width: 100%;
    max-width: 32px;
    height: auto;
    object-fit: contain;
}

/* --- Bottom bar --- */
.txFooter .txFooterBottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding-top: 26px;
    border-top: 1px solid #f1f4f729;
}

.txFooter .txFooterBottom p {
    margin: 0;
    font-size: 13px;
    color: #888e9d;
    font-family: 'Manrope-SemiBold', sans-serif;
}

.txFooter .txSecure {
    display: flex;
    align-items: center;
    gap: 8px;
}

.txFooter .txSecure i {
    color: var(--gold-color, #ecbb33);
    font-size: 12px;
}

.payment-instructions {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 8px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;

    font-size: 13px;
    line-height: 20px;
    color: #64748b;
}

.payment-instructions > i {
    flex-shrink: 0;
    color: #64748b;
}

.payment-instructions a {
    margin-left: 3px;
    color: #b8860b;
    font-weight: 500;
    text-decoration: none;
}

.payment-instructions a:hover {
    text-decoration: underline;
}

/* --- Responsive --- */
@media (max-width: 991px) {
    .txFooter .txFooterGrid {
        grid-template-columns: 1fr 1fr;
        gap: 32px;
    }
}

@media (max-width: 575px) {
    .txFooter .txFooterGrid {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    .txFooter .txFooterBrand p {
        max-width: 100%;
    }

    .txFooter .txFooterBottom {
        flex-direction: column;
        align-items: flex-start;
    }
}
/* Tour starting status info card */
.tourStatusInfo {
    display: flex;
    align-items: center;
    gap: 24px;
    border: 1px solid #006FEE66;
    padding: 20px 25px;
}

.tourStatusInfo .tourStatusHead {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 260px;
}

.tourStatusInfo .tourStatusIcon {
    width: 46px;
    height: 46px;
    min-width: 46px;
    border-radius: 50%;
    background-color: #006FEE1A;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tourStatusInfo .tourStatusIcon i {
    color: #006FEE;
    font-size: 20px;
    line-height: 1;
}

.tourStatusInfo .tourStatusTitle h6 {
    font-family: 'Manrope-Bold';
    font-size: 16px;
    color: var(--text-black);
    margin-bottom: 2px;
}

.tourStatusInfo .tourStatusTitle p {
    font-size: 12px;
    color: var(--textP-color);
    margin-bottom: 0;
}

.tourStatusInfo .tourStatusList {
    display: flex;
    align-items: flex-start;
    flex: 1 1;
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

.tourStatusInfo .tourStatusList li {
    flex: 1 1;
    padding: 0 20px;
}

.tourStatusInfo .tourStatusList li+li {
    border-left: 1px solid var(--border-color);
}

.tourStatusInfo .tourStatusList li p {
    font-size: 13px;
    color: var(--textP-color);
    margin: 8px 0 0;
}

.tourStatusInfo span.comtagSpan {
    display: inline-block;
    padding: 0px 10px;
    border-radius: 5px;
    font-size: 14px;
    font-family: 'Manrope-SemiBold' !important;
}

.tourStatusInfo span.comtagSpan.green {
    background-color: #17C96433;
    color: #09A54D;
}

.tourStatusInfo span.comtagSpan.blue {
    background-color: #006FEE33;
    color: #006FEE;
}

.tourStatusInfo span.comtagSpan.yellow {
    background-color: #FFE69C;
    color: #B58100;
}

body.dark .tourStatusInfo .tourStatusTitle h6 {
    color: var(--light-text);
}

body.dark .tourStatusInfo .tourStatusList li+li {
    border-left-color: #3a3a3a;
}

@media (max-width: 991px) {
    .tourStatusInfo {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .tourStatusInfo .tourStatusList {
        width: 100%;
    }

    .tourStatusInfo .tourStatusList li:first-child {
        padding-left: 0;
    }
}

@media (max-width: 575px) {
    .tourStatusInfo .tourStatusList {
        flex-direction: column;
        gap: 14px;
    }

    .tourStatusInfo .tourStatusList li {
        padding: 0;
    }

    .tourStatusInfo .tourStatusList li+li {
        border-left: unset;
        border-top: 1px solid var(--border-color);
        padding-top: 14px;
    }

    body.dark .tourStatusInfo .tourStatusList li+li {
        border-top-color: #3a3a3a;
    }
}

/* Payment & Invoicing Rules page */
.pay_rules .pay_rules_section:not(:last-child) {
    margin-bottom: 32px;
}

.pay_rules h5 {
    color: #23262F;
    font-family: 'Manrope-Bold';
    font-size: 20px;
    margin-bottom: 12px;
}

.pay_rules p,
.pay_rules ul li {
    color: #23262F;
    font-family: 'Manrope-Medium';
    font-size: 16px;
    line-height: 1.7;
}

.pay_rules p {
    margin-bottom: 12px;
}

.pay_rules strong {
    font-family: 'Manrope-Bold';
    font-weight: 700;
}

.pay_rules ul {
    padding-left: 22px;
    margin-bottom: 0;
}

.pay_rules ul li {
    list-style: disc;
    display: list-item;
    margin-bottom: 8px;
}

.pay_rules ul ul {
    margin-top: 8px;
}

.pay_rules ul ul li {
    list-style: circle;
}

.pay_rules ul ul ul li {
    list-style: square;
}

.pay_rules .pay_rules_mark {
    background-color: #F9F3DC;
    color: #6c5508;
    padding: 1px 5px;
    border-radius: 4px;
}

.pay_rules .pay_rules_danger {
    color: #e73e46;
}

body.dark .pay_rules p,
body.dark .pay_rules ul li {
    color: var(--light-text);
}

body.dark .pay_rules .pay_rules_mark {
    background-color: rgba(227, 189, 62, 0.15);
    color: var(--gold-color);
}

/* ====== Recharge plans: credits explainer ====== */
.credits-explainer {
    width: 100%;
    background-color: #fff;
    border: 1px solid #e3bd3e;
    border-radius: 20px;
    padding: 1.5rem 2rem;
    font-family: 'Manrope-Regular';
}

.credits-explainer h5 {
    font-family: 'Manrope-Bold';
    color: #23252E;
    margin: 0 0 6px;
}

.credits-explainer > p {
    color: #888E9D;
    margin: 0 0 16px;
}

.credits-steps {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.credits-step {
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #f5f5f0;
    border-radius: 14px;
    padding: 14px 16px;
}

.credits-step--wide {
    grid-column: 1 / -1;
}

.credits-step-num {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 50%;
    background-color: #e3bd3e;
    color: #fff;
    font-family: 'Manrope-Bold';
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.credits-step strong {
    display: block;
    font-family: 'Manrope-Bold';
    color: #23252E;
    font-size: .95rem;
}

.credits-step span:not(.credits-step-num) {
    color: #888E9D;
    font-size: .9rem;
}

.credits-step a {
    color: #c5a132;
    font-weight: 600;
    text-decoration: underline;
}

body.dark .credits-explainer {
    background-color: var(--dark-box);
}

body.dark .credits-explainer h5,
body.dark .credits-step strong {
    color: var(--white-color);
}

body.dark .credits-step {
    background-color: var(--body-dark);
}

@media (max-width: 575px) {
    .credits-explainer {
        padding: 1.25rem;
    }

    .credits-steps {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assest/css/custom.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA,KAAK;AACL;;IAEI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IAEZ,+CAA+C;AACnD;;AAYA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;GAEG;;AAEH,gBAAgB;AAChB;IACI,oCAAoC;AACxC;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,uCAAuC;AAC3C;;;AAGA;;GAEG;AACH;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,UAAU;QACV,4BAA4B;IAChC;AACJ;;AAEA;;;IAGI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;;;IAGI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,uDAAuD;IACvD,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gDAAgD;IAChD,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8CAA8C;IAC9C,kDAAkD;AACtD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,sCAAsC;AAC1C;;;AAGA;IACI,2DAA2D;AAC/D;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;AAC1B;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;;AAEjC;;AAEA;IACI,4BAA4B;;AAEhC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,oCAAoC;IACpC,2BAA2B;IAC3B,6BAA6B;IAC7B,4CAA4C;AAChD;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;IAEI,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mCAAmC;IACnC,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,WAAW;IACX,4BAA4B;;AAEhC;;AAEA;IACI,aAAa;IACb,WAAW;;AAEf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,oEAA2D;AAC/D;;AAEA;IACI,oEAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,KAAK;AACL;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,gBAAgB;;AAEhB;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,8BAA8B;IAC9B,gDAAgD;AACpD;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,wDAAwD;IACxD,8CAA8C;IAC9C,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;IACxB,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,qCAAqC;IACrC,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,0CAA0C;IAC1C,6BAA6B;AACjC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;;;IAGI,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,yCAAyC;IACzC,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,2CAA2C;;AAE3C;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,qDAAqD;IACrD,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,0DAA0D;AAC9D;;AAEA,yCAAyC;AACzC;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA;IACI;wBACoB;IACpB,mBAAmB;IACnB,qCAAqC;IACrC;;mBAEe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA,KAAK;;AAEL;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;AACA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,yBAAyB;QACzB,mBAAmB;QACnB,2BAA2B;QAC3B,eAAe;QACf,cAAc;IAClB;IACA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;IACb;IACA;QACI,gCAAgC;IACpC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IAExC,2BAA2B;IAC3B,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;IAGI,uCAAuC;AAC3C;;AAEA;;;IAGI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;IACzC,uCAAuC;IACvC,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA,KAAK;AACL;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB;;0CAEsC;IACtC,4EAA4E;IAC5E,iCAAiC;AACrC;;AAEA;IACI;QACI;IACJ;AACJ;;;AAGA;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;;AAElB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;;AAElB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;;IAEI,qBAAqB;IACrB,2CAA2C;IAC3C,QAAQ;IACR,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;IACd,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kEAAkE;AACtE;AACA;IACI,kEAAkE;AACtE;AACA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,sDAAsD;AACtD;IACI,qCAAqC;AACzC;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;IAC7C,uDAAuD;AAC3D;AACA;IACI,8CAA8C;IAC9C,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;;AAGA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kFAAkF;IAClF,yBAAyB;IACzB,gCAAgC;IAChC,2EAA2E;IAC3E,cAAc;IACd,mCAAmC;IACnC,aAAa;IACb,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,4CAA4C;IAC5C,oCAAoC;IACpC,2BAA2B;IAC3B,0BAA0B;IAC1B,sCAAsC;IACtC,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,0EAA0E;IAC1E,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,8BAA8B;;AAElC;;AAEA,eAAe;AACf;IACI,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,2EAA2E;IAC3E,mCAAmC;IACnC,kBAAkB;IAClB,wDAAwD;IACxD,6BAA6B;AACjC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,KAAK;AACL,iBAAiB;AACjB;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,aAAa;AACjB;;AAEA,SAAS;AACT;;;GAGG;;AAEH,KAAK;AACL;IACI,aAAa;IACb,8DAA8D;IAC9D,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;8DAE8D;AAC9D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB;;oFAEgF;AACpF;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;AACf;AACA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,QAAQ;IACR,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oFAAoF;IACpF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,+CAA+C;IAC/C,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,gFAAyR;AAC7R;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,8EAAyT;AAC7T;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,6DAA6D;IAC7D,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;AACpD;AACA;IACI,6DAA6D;AACjE;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,QAAQ;IACZ;IACA;QACI,YAAyB;QAAzB,cAAyB;QAAzB,2BAAyB;QACzB,kBAAkB;QAClB,2BAA2B;IAC/B;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;;8DAE8D;AAC9D;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0CAA0C;AAC9C;;AAEA,2EAA2E;AAC3E;IACI,iBAAiB;IACjB,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,UAAU;AACd;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,+EAA+E;IAC/E,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;;AAEA,iCAAiC;AACjC;IACI,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yEAAyE;IACzE,0BAA0B;IAC1B,aAAa;IACb,UAAU;AACd;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mDAAmD;AACvD;AACA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;AAC1B;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,iDAAiD;AACrD;AACA;;;IAGI,oCAAoC;IACpC,sCAAsC;IACtC,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,cAAc;QACd,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,gCAAgC;IACpC;IACA;QACI,eAAe;QACf,SAAS;IACb;IACA;;QAEI,cAAc;IAClB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yDAAiS;AACrS;AACA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,oEAAqK;AACzK;;AAEA,KAAK;;AAEL;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mDAAmD;IACnD,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,KAAK;AACL;IACI,yBAAyB;IACzB,cAAc;IACd,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,gBAAgB;;AAEpB;;AAEA;;;+EAG+E;;AAE/E;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,4CAA4C;IAC5C,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;IAC1C,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;IACrB,qCAAqC;IACrC,wDAAwD;AAC5D;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,+BAA+B;IAC/B,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;IAC1C,eAAe;IACf,eAAe;AACnB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;IACrB,uDAAuD;AAC3D;;AAEA;IACI,4CAA4C;IAC5C,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;;IAEzB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,uBAAuB;AACvB;IACI;QACI,8BAA8B;QAC9B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;AACA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,yCAAyC;QACzC,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;IAC1C,wBAAwB;AAC5B;;AAEA,oDAAoD;AACpD;IACI,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".cus-err {\n    color: #D8000C;\n    position: absolute;\n    left: 5px;\n    bottom: 0px;\n    font-size: 13px;\n}\n\n.innerFormBox .box-box,\n.boxFull,\n.fillDetails .nameBox .box-box {\n    position: relative;\n}\n\n.innerFormBox .box-box .cus-err,\n.boxFull .cus-err {\n    bottom: -20px;\n}\n\n/*  */\n.iti,\n.iti--allow-dropdown {\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.reg-g-captcha-main {\n    position: relative;\n    padding: 10px 0 20px;\n}\n\n.iti__tel-input {\n    width: 100%;\n    padding: 10px 15px;\n    border-radius: 12px;\n    outline: none !important;\n    box-shadow: none !important;\n    border: 2px solid #E6E8EC;\n    /* margin-bottom: 15px; */\n    margin-bottom: 20px;\n}\n\n/* Loader */\n.preloader {\n    position: fixed;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    opacity: 0.5;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    z-index: 2000 !important;\n}\n\n.preloader span {\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 2px;\n    margin-top: 15px;\n}\n\n.preloader .preloader-icon,\n.inside-loader .preloader-icon {\n    border: 2px solid #eeeeee;\n    border-radius: 50%;\n    border-top: 2px solid #E3BD3E;\n    width: 70px;\n    height: 70px;\n    -webkit-animation: spin 0.5s linear infinite !important;\n    animation: spin 0.5s linear infinite !important;\n}\n\n@-webkit-keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* .no-scroll {\n    overflow: hidden;\n} */\n\n/* Loader Ends */\n.commonInput.greenSpan {\n    border: 2px solid #2ABC30 !important;\n}\n\n\n\n.adultDropBox {\n    max-height: 0;\n    /* overflow: hidden; */\n    transition: max-height 0.2s ease-in-out;\n}\n\n\n/* .adultDropBox {\n    display: block;\n} */\n.bookRightBox .selectDate .multyDrop .adultDropBox ul {\n    background-color: white;\n}\n\n@keyframes slideDown {\n    from {\n        max-height: 0;\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n\n    to {\n        max-height: 150px;\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes slideUp {\n    from {\n        max-height: 150px;\n        opacity: 1;\n        transform: translateY(0);\n    }\n\n    to {\n        max-height: 0;\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n}\n\n.adultDropBox.open,\n.dateBoxLeft.open,\n.timeDropBox.open {\n    display: block;\n    animation: slideDown 0.2s ease-out forwards;\n}\n\n.adultDropBox.close,\n.dateBoxLeft.close,\n.timeDropBox.close {\n    animation: slideUp 0.2s ease-out forwards;\n}\n\n.flatpickr-input {\n    padding: 20px 20px;\n    box-shadow: 0px 0px 10px var(--border-color) !important;\n    border-radius: 15px;\n    background: white;\n}\n\nbody.dark .flatpickr-input {\n    background-color: #1f1f1f;\n}\n\n.detailsSlider .sliderImg {\n    max-height: 550px;\n}\n\n.accessibleBox .typecheck .form-check-input:checked,\n.form-radio-warning .form-check-input:checked {\n    background-color: #F5A524;\n    border-color: #F5A524;\n}\n\n.accessibleBox .typecheck .form-check-input {\n    box-shadow: none !important;\n    outline: none !important;\n    margin-right: 10px;\n    height: 20px;\n    width: 20px;\n    border: 2px solid var(--border-color);\n}\n\n.accessibleBox .typecheck {\n    padding-left: 0 !important;\n}\n\n.ql-editor {\n    width: 100% !important;\n    max-width: 100% !important;\n    word-break: break-word !important;\n    min-height: 150px !important;\n}\n\n.boxCard.disabled {\n    /* opacity: 0.5; */\n    pointer-events: none;\n}\n\n.main.disabled {\n    cursor: not-allowed;\n    background: #fafafa;\n    border: 2px solid var(--border-color) !important;\n    color: black !important;\n}\n\n.suggestUp span.cus-err {\n    bottom: -22px !important;\n}\n\n.suggestUp {\n    position: relative !important;\n}\n\n.bokunDropBox .DropBox li a .langflag {\n    margin-right: 10px;\n    height: 15px;\n    width: 15px;\n}\n\n.bokunDropBox .DropBox li a .langflag img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n}\n\n.DropBox {\n    top: 60px !important;\n}\n\n.css-t3ipsp-control {\n    border: 1px solid var(--gold-color) !important;\n    box-shadow: 0 0 0 1px var(--gold-color) !important;\n}\n\n.css-13cymwt-control {\n    border: 2px solid var(--border-color) !important;\n}\n\n.css-v7duua:hover {\n    background-color: var(--gold-color) !important;\n    color: black !important;\n}\n\n#exampleModal .modal-title {\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.bookingCategory.bookingCategorydesktop.privateBox .commongridbox {\n    grid-template-columns: 420px 1fr 1fr;\n}\n\n.seatsBox .commonLabelSecond i {\n    line-height: normal;\n}\n\n.bookingCategory .commongridbox {\n    align-items: center;\n}\n\n.bookingCategory .commongridbox .commonLabelSecond {\n    padding-bottom: 0;\n}\n\n.rate_title .commonLabelSecond {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n}\n\n.rate_title .commonLabelSecond i {\n    font-size: 18px;\n    /* margin-right: 15px; */\n    color: #94A3B8 !important;\n    vertical-align: middle;\n    float: left;\n    margin: 0 15px 0 0px !important;\n}\n\n.tripPrices .costBox table td.commisoin {\n    padding: 15px !important;\n}\n\n.costBox .table>:not(:last-child)>:last-child>* {\n    border-bottom: none !important;\n}\n\n\n.table-striped>tbody>tr:nth-of-type(odd) {\n    --bs-table-accent-bg: unset !important;\n}\n\n\n.table-striped>tbody>tr:nth-of-type(even) {\n    --bs-table-accent-bg: var(--bs-table-striped-bg) !important;\n}\n\n\n.dateBoxLeft .dayContainer {\n    gap: 5px !important;\n}\n\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n    fill: unset !important;\n}\n\n\n.prevMonthDay {\n    visibility: hidden !important;\n}\n\n.nextMonthDay {\n    visibility: hidden !important;\n\n}\n\n.dateBoxLeft .flatpickr-calendar {\n    box-shadow: unset !important;\n\n}\n\n.available-date {\n    background-color: #FDF7E8 !important;\n    color: #334155 !important;\n    /* border-radius: 50% !important;  */\n}\n\n/* Dot under the highlighted date */\n.bookable-date::after {\n    content: \"\";\n    display: block;\n    width: 5px;\n    height: 5px;\n    background-color: #ECBB33 !important;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.flatpickr-day {\n    border-radius: 10px !important;\n    font-family: 'Manrope-SemiBold' !important;\n    /* Make the input square */\n}\n\n.flatpickr-day.selected {\n    background-color: #ECBB33 !important;\n    color: #44444F !important;\n    border-color: #ECBB33 !important;\n}\n\n.flatpickr-day.selected.bookable-date::after {\n    background-color: #44444F !important;\n\n}\n\n.dateBoxLeft .flatpickr-current-month {\n    width: 64% !important;\n    left: 0 !important;\n}\n\n.dateBoxLeft .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {\n    left: 75% !important;\n}\n\n.dateBoxLeft .flatpickr-prev-month,\n.dateBoxLeft .flatpickr-next-month {\n    border: 2px solid #E6E8EC !important;\n    padding: 3px 9px !important;\n    border-radius: 8px !important;\n    box-shadow: 0px 1px 2px #0D0D120F !important;\n}\n\n.dateBoxLeft .flatpickr-prev-month svg,\n.dateBoxLeft .flatpickr-next-month svg {\n    width: 12px !important;\n    height: 12px !important;\n}\n\n.dateBoxLeft select.flatpickr-monthDropdown-months,\ninput.cur-year {\n    font-family: 'Nunito', sans-serif !important;\n    font-weight: 700 !important;\n}\n\n.dateBoxLeft .flatpickr-months {\n    margin-bottom: 10px;\n    /* padding-bottom: 15px; */\n    border-bottom: 1px solid #E6E8EC;\n}\n\n.dateBoxLeft .commonLabelSecond {\n    padding-bottom: 0 !important;\n    margin-bottom: 10px !important;\n}\n\n.commonGoldBtn {\n    background-color: #E3BD3E !important;\n}\n\n.custom-ui {\n    text-align: center;\n    width: 500px;\n    padding: 40px;\n    /* background: #28bae6; */\n    background-color: var(--gold-color);\n    color: var(--text-black) !important;\n    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);\n    /* color: #fff !important; */\n    border-radius: 10px !important;\n}\n\n.custom-ui>button {\n    width: 160px !important;\n    padding: 10px !important;\n    border: 1px solid #fff;\n    margin: 10px !important;\n    cursor: pointer;\n    background: none;\n    color: #fff;\n    font-size: 14px;\n}\n\n.custom-ui>h1 {\n    font-family: 'Manrope-SemiBold' !important;\n    margin-top: 0;\n    color: #fff;\n    font-size: 2.5rem !important;\n\n}\n\n.custom-ui>p {\n    margin-top: 0;\n    color: #fff;\n\n}\n\n.imgText {\n    cursor: pointer !important;\n}\n\n.custom-ui button:hover {\n    background: white !important;\n    color: var(--gold-color) !important;\n}\n\n.activityMain .activityFillSec .mainTabBox .nav .nav-link.mainLink.active::after {\n    background-image: url('../images/component.png') !important;\n}\n\n.activityMain .activityFillSec .mainTabBox .nav .nav-link.mainLink.active.complete::after {\n    background-image: url('../images/tick-circle.png') !important;\n}\n\n.discriplangDown a.main .langflag {\n    margin-right: 10px;\n    height: 15px;\n    width: 15px;\n}\n\n.discriplangDown a.main .langflag img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n}\n\n.imgUpload .imageImprot .cus-err,\n.meetingLoact .uploadBox .cus-err {\n    position: absolute;\n    bottom: -20px;\n}\n\n#allimgBox {\n    padding-top: 15px;\n}\n\n/*  */\n.showList .box-box h5 span.spanCom {\n    height: 45px;\n    width: 45px;\n    display: inline-flex;\n    background-color: transparent !important;\n    border-radius: 5px;\n    margin-right: 15px;\n    vertical-align: middle;\n    align-items: center;\n    justify-content: center;\n}\n\n.showList .box-box h5 {\n    color: #64748B;\n    font-size: unset !important;\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.showList .box-box h5 span.yellowBg {\n    background-color: #FDF7E8 !important;\n    position: relative;\n}\n\n.showList .box-box h5 span.yellowBg::after {\n    content: \"\";\n    display: block;\n    width: 5px;\n    height: 5px;\n    background-color: #ECBB33 !important;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.showList .box-box h5 span.whiteBg {\n    position: relative;\n}\n\n.showList .box-box h5 span.whiteBg::after {\n    content: \"\";\n    display: block;\n    width: 5px;\n    height: 5px;\n    background-color: #ECBB33 !important;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.showList {\n    border-top: 1px solid #E6E8EC !important;\n}\n\n.productDuration .dateBoxLeft {\n    padding: 0 10px !important;\n}\n\n.themeCheck:checked {\n    background-color: #E3BD3E !important;\n    border-color: #E3BD3E !important;\n}\n\n.themeCheck:focus {\n    border-color: #E3BD3E;\n    outline: 0;\n    box-shadow: 0 0 0 .25rem #e3bd3e85 !important\n}\n\n.cropper-container {\n    width: auto !important;\n}\n\n#croppedImage {\n    max-width: 600px;\n    max-height: 300px;\n    width: auto;\n    height: auto;\n}\n\n.loc-select-input .css-b62m3t-container {\n    width: 100% !important;\n    margin-right: 10px !important;\n}\n\n.location-div .cus-err {\n    bottom: -10px;\n}\n\n.loginSec input::placeholder {\n    color: #BDBDBD !important;\n}\n\n.loc-select-input .css-3iigni-container {\n    width: 100% !important;\n    margin-right: 10px !important;\n}\n\n.getOtpBox .cus-err {\n    position: relative;\n}\n\n.loginSec.signUp .iti {\n    display: flex !important;\n    gap: 10px !important;\n}\n\n.loginSec.signUp .iti__country-container {\n    position: unset !important;\n    border-radius: 12px;\n    border: 2px solid #E6E8EC;\n    width: 140px;\n}\n\n.loginSec.signUp .iti__tel-input {\n    padding-left: 10px !important;\n}\n\n.loginSec.signUp .iti__selected-country {\n    width: 100%;\n}\n\n.loginSec.signUp .iti__arrow {\n    border-left: 0 !important;\n    border-right: 0 !important;\n    margin-left: 0 !important;\n}\n\n.iti__arrow::after {\n    content: '\\f078';\n    font-family: 'fontawesome';\n    position: absolute;\n    right: 4px;\n    font-size: 11px;\n    margin-left: 10px;\n    height: 25px;\n    width: 25px;\n    border: 2px solid #E6E8EC;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.iti .iti__selected-dial-code {\n    margin-left: 3px !important;\n}\n\n.iti__selected-country-primary {\n    padding-right: 0 !important;\n}\n\n.iti__selected-country-primary:hover {\n    background-color: transparent !important;\n}\n\n.iti__search-input {\n    outline: none !important;\n    border: 2px solid #E6E8EC;\n    padding: 10px 15px;\n    border-radius: 12px;\n}\n\n.req-sym {\n    color: #fa5c7c;\n    margin-left: 0.3rem;\n}\n\n.companyProfilePage .boxCard {\n    position: relative;\n\n}\n\n.companyProfilePage .cus-err {\n    bottom: -20px;\n}\n\nbody.dark .activityhead .backBox a,\nbody.dark .activityhead .backBox a i {\n    color: #B1B5C3 !important;\n    border-color: #334155 !important;\n    background-color: #2C2C2C !important;\n}\n\nbody.dark .rightTabcontent .pagenext .pageList p {\n    color: #B1B5C3 !important;\n\n}\n\n.userAc {\n    display: block !important;\n}\n\n.select2.select2-container {\n    width: 100% !important;\n}\n\n.select2.select2-container .selection {\n    width: 100% !important;\n}\n\n.select2.select2-container .selection .select2-selection {\n    border: 2px solid #E6E8EC;\n    display: flex;\n    align-items: center;\n    /* padding: 20px 0px; */\n    height: 48px;\n    border-radius: 10px;\n    /* width: 250px; */\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    top: unset !important;\n}\n\ninput.select2-search__field {\n    outline: 0 !important;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background-color: #e3bd3e !important;\n    color: #1f1f1f !important;\n}\n\n.redColorText {\n    color: #950606 !important;\n}\n\n.commonLabel {\n    width: 100%;\n    padding-bottom: 5px;\n    color: #292929;\n    font-family: 'Manrope-Regular';\n}\n\n.dashboard {\n    font-family: 'Manrope-Regular';\n}\n\n/* Date Picker */\n\n.react-date-picker {\n    width: 100%;\n}\n\n.react-date-picker__wrapper {\n    border: none !important;\n    padding: 8px 15px !important;\n    border-radius: 12px !important;\n    border: 2px solid var(--border-color) !important;\n}\n\n.react-date-picker__inputGroup {\n    /* color: #7A7C86 !important; */\n    font-size: 14px !important;\n    font-family: 'Manrope-Medium' !important;\n}\n\n.react-date-picker__button svg {\n    stroke: #7A7C86 !important;\n}\n\n.react-date-picker__button svg:hover {\n    stroke: #E3BD3E !important;\n}\n\n.react-calendar {\n    border: none !important;\n    border-radius: 30px;\n    background-color: #FCFCFD !important;\n    /* box-shadow: 0 40px 32px -24px #0F0F0F1F !important; */\n    box-shadow: 0 0px 5px 0px #0F0F0F1F !important;\n    padding: 15px 10px !important;\n}\n\n.react-calendar__month-view .react-calendar__tile {\n    font-size: 14px !important;\n    width: 50px !important;\n    max-width: 45px !important;\n    height: 45px;\n    font-family: 'Poppins-Medium' !important;\n}\n\n.react-calendar__month-view .react-calendar__tile--active {\n    color: #171202 !important;\n    border-radius: 50% !important;\n    background: #ECBB33 !important;\n    padding: 0 !important;\n}\n\n/* .react-calendar__month-view__days__day--neighboringMonth {\n    color: #171202 !important;\n} */\n\n.react-calendar__month-view__days {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr !important;\n}\n\n.react-calendar__month-view .react-calendar__month-view__weekdays {\n    color: #83889B !important;\n    font-family: 'Gilory-SemiBold' !important;\n    text-transform: capitalize !important;\n    text-decoration: none !important;\n    font-size: 14px !important;\n}\n\n.react-calendar__month-view .react-calendar__month-view__weekdays abbr[title] {\n    text-decoration: unset !important;\n    font-family: 'Gilory-SemiBold' !important;\n}\n\n.react-calendar__month-view .react-calendar__month-view__days__day--weekend {\n    color: #171202 !important;\n}\n\n.react-calendar__navigation .react-calendar__navigation__label__labelText {\n    font-size: 18px;\n    color: #171202;\n    font-family: 'Manrope-Bold' !important;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n    color: #757575 !important;\n}\n\n.react-calendar__tile--now {\n    background: transparent !important;\n}\n\n.react-calendar__month-view .react-calendar__tile:enabled:hover,\n.react-calendar__month-view .react-calendar__tile:enabled:focus {\n    /* background-color: #ECBB33 !important; */\n    border-radius: 50% !important;\n}\n\n.react-calendar__year-view .react-calendar__tile--hasActive,\n.react-calendar__decade-view__years .react-calendar__tile--hasActive,\n.react-calendar__century-view__decades .react-calendar__tile--hasActive {\n    background: #ECBB33 !important;\n}\n\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view__years .react-calendar__tile,\n.react-calendar__century-view__decades .react-calendar__tile {\n    padding: 12px 20px !important;\n    border-radius: 30px;\n    color: #171202 !important;\n    font-size: 14px !important;\n    font-family: 'Gilory-SemiBold' !important;\n    /* font-family: 'Gilroy-Bold'!important; */\n    margin-bottom: 10px !important;\n}\n\n.react-calendar__century-view__decades .react-calendar__tile {\n    padding: 12px 5px !important;\n}\n\n/* Date Picker End */\n\n.booking-pagination-par .pagenext {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* ========= skaleton css start ========= */\n\n@keyframes skeleton-loading {\n    0% {\n        background-color: #d6d6d0;\n    }\n\n    50% {\n        background-color: #e0e0d9;\n    }\n\n    100% {\n        background-color: #d6d6d0;\n    }\n}\n\n@keyframes skeleton-loading-dark {\n    0% {\n        background-color: #2F2304;\n    }\n\n    50% {\n        background-color: #241b06;\n    }\n\n    100% {\n        background-color: #2F2304;\n    }\n}\n\n.skeleton {\n    position: relative;\n}\n\n.skeleton::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    animation: skeleton-loading 1.5s infinite ease-in-out;\n    z-index: 55;\n    border-radius: 10px;\n}\n\nbody.dark .skeleton::after {\n    animation: skeleton-loading-dark 1.5s infinite ease-in-out;\n}\n\n/* ========= skaleton css end ========= */\n.drop-border-unset a {\n    border: unset !important;\n}\n\n.booking-product-list-select .select2-selection__rendered {\n    width: 100% !important;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.resendbtn {\n    color: #292D32;\n    background-color: #E3BD3E;\n    border: unset;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.cancelbtn {\n    background-color: #DC2626;\n    border: unset;\n    color: white;\n\n}\n\n.detailsMore span.greenstatuspaid {\n    background: #17C964;\n    padding: 0px 10px;\n    border-radius: 5px;\n    font-size: 12px;\n    color: black;\n    padding: 4px 4px;\n}\n\n.detailsMore span.comtagSpan {\n    padding: 0px 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.detailsMore span.comtagSpan.green {\n    background-color: #17C96433;\n    color: #09A54D;\n}\n\n.detailsMore span.comtagSpan.blue {\n    background-color: #006FEE33;\n    color: #006FEE;\n}\n\n.detailsMore span.comtagSpan.yellow {\n    background-color: #FFE69C;\n    /* bright amber background */\n    color: #B58100;\n    /* strong amber text */\n}\n\n.emptyimgBox {\n    text-align: center;\n    padding: 50px 0 80px;\n}\n\n.emptyimgBox h5 {\n    color: #23262F;\n    font-family: 'Manrope-Bold';\n    margin: 20px 0 10px;\n}\n\n.emptyimgBox p {\n    color: #64748B;\n    font-family: 'Manrope-Bold';\n    font-size: 14px;\n}\n\n.custom-file-upload {\n    cursor: pointer;\n    color: var(--gold-color);\n    text-decoration: none;\n    /* font-size: 14px; */\n    display: inline-flex;\n    align-items: center;\n}\n\n.custom-file-upload i {\n    margin-right: 5px;\n}\n\n\n.rightProfile .rightProfileMain .userImgBox .updateImg label {\n    color: var(--gold-color);\n    font-family: 'Manrope-SemiBold';\n    margin-top: 10px;\n}\n\n#avatarInput {\n    display: none;\n}\n\n.iti__arrow::after {\n    content: '\\f078';\n    font-family: 'fontawesome';\n    position: absolute;\n    right: 4px;\n    font-size: 11px;\n    margin-left: 10px;\n    height: 25px;\n    width: 25px;\n    border: 2px solid #E6E8EC;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.iti,\n.ourdetailProfile.profileImport .iti {\n    display: flex !important;\n    gap: 10px !important;\n}\n\n.iti__country-container,\n.ourdetailProfile.profileImport .iti__country-container {\n    position: unset !important;\n    border-radius: 12px;\n    border: 2px solid #E6E8EC;\n    width: 170px;\n}\n\n.iti__selected-country,\n.ourdetailProfile.profileImport .iti__selected-country {\n    width: 100%;\n}\n\n.iti__arrow,\n.ourdetailProfile.profileImport .iti__arrow {\n    border-left: 0 !important;\n    border-right: 0 !important;\n    margin-left: 0 !important;\n}\n\n.iti .iti__selected-dial-code {\n    margin-left: 3px !important;\n}\n\n.iti__tel-input,\n.ourdetailProfile.profileImport .iti__tel-input {\n    padding-left: 10px !important;\n}\n\n.rightProfile .rightProfileMain .userPersonaldet {\n    margin-bottom: 100px;\n}\n\n.custom-switch .form-check-input:checked {\n    background-color: var(--gold-color);\n    border-color: var(--gold-color);\n}\n\n.custom-switch .form-check-input:focus {\n    box-shadow: unset;\n}\n\n.righttableSec .addTeam .btnGold i {\n    margin-right: 10px;\n    color: #23252E;\n}\n\n.righttableSec .addTeam .btnGold {\n    background-color: var(--gold-color);\n    color: var(--text-black) !important;\n}\n\n.commonFileInputSecond {\n    /* width: 100%;\n    padding: 8px 15px; */\n    border-radius: 12px;\n    border: 2px solid var(--border-color);\n    /* box-shadow: none;\n    outline: none;\n    height: 48px; */\n}\n\n.add-sup-form .cus-err {\n    position: relative;\n}\n\n.custom-switch .form-check-input:focus {\n    border-color: var(--gold-color);\n    outline: 0;\n    box-shadow: unset;\n}\n\ntable.teamTable {\n    border-collapse: separate;\n    border-spacing: 0 0.5em;\n}\n\n.importBox .cus-err {\n    position: relative;\n    bottom: 0px !important;\n}\n\n.soarting {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 5px;\n}\n\n.soarting .icons {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.soarting .icons i {\n    font-size: 7px;\n    color: #94A3B8;\n}\n\n.opacityDown {\n    opacity: 0.5;\n}\n\n.opacitUp {\n    opacity: 0.5;\n}\n\nspan.red {\n    color: #F31260;\n    /* Red color */\n    background-color: #F3126033;\n    /* Light red background */\n}\n\n.unpublished-tour {\n    background: #f3f3f3;\n    opacity: 0.5;\n}\n\n.header_sortable {\n    cursor: pointer;\n}\n\n.header_sortable:hover {\n    background: #ebeff3;\n}\n\n.b-20 {\n    bottom: -20px;\n}\n\n.b-3 {\n    bottom: -3px;\n}\n\n.verification-modal .modal-dialog {\n    max-width: 480px;\n}\n\n.verification-modal .modal-content {\n    border-radius: 16px;\n}\n\n.verification-modal .modal-body {\n    text-align: center;\n    padding: 30px 30px;\n}\n\n.verification-modal .modal-body a>img {\n    width: 100%;\n    max-width: 190px;\n}\n\n.verification-modal .modal-body h4 {\n    color: #0F172A;\n    font-size: 30px;\n    margin: 15px 0;\n    font-family: 'Gilroy-Bold';\n}\n\n.verification-modal .modal-body h6 {\n    font-size: 14px;\n    color: #94A0AD;\n    margin-bottom: 25px;\n    font-family: 'Gilroy-Bold';\n}\n\n.verification-modal .modal-body .register p {\n    color: #475569;\n    font-size: 16px;\n    font-family: 'Manrope-SemiBold';\n    margin-top: 20px;\n}\n\n.verification-modal .modal-body .register p a {\n    font-family: 'Manrope-SemiBold';\n}\n\n.verification-modal.confirmation-modal .modal-dialog {\n    max-width: 567px;\n}\n\n.verification-modal.confirmation-modal .modal-body h4 {\n    color: #23262F;\n    font-family: 'Manrope-Bold' !important;\n}\n\n.verification-modal.confirmation-modal .modal-body h6 {\n    color: #94A3B8;\n    font-family: 'Manrope-Bold' !important;\n}\n\n.verification-modal.confirmation-modal .continueBox {\n    display: flex;\n    gap: 10px;\n}\n\n.verification-modal.confirmation-modal .continueBox .continueBtn {\n    width: calc(50%);\n    background: #fff;\n    border: 1px solid var(--gold-color);\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.verification-modal.confirmation-modal .continueBox .continueBtn:hover {\n    background: var(--gold-color);\n}\n\n.modal-backdrop.show {\n    opacity: .9;\n    background-color: #171202;\n}\n\n/*  */\n\n.arrow {\n    transition: transform 0.3s ease;\n}\n\n.arrow.rotate {\n    transform: rotate(180deg);\n}\n\n.submenu {\n    display: block !important;\n    max-height: 0;\n    padding-top: 0px !important;\n    overflow: hidden;\n    transition: max-height 0.4s ease-in-out !important;\n}\n\n.submenu.open {\n    max-height: 200px !important;\n    /* Adjust based on submenu content */\n}\n\n.mainListProducts .tabBtnbox ul li {\n    margin: 10px 0;\n}\n\n/* Mobile collapsible sidebar menu (Option A) */\n.mobileMenuToggle {\n    display: none;\n}\n@media (max-width: 991px) {\n    .mobileMenuToggle {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        padding: 13px 18px;\n        background: #ffffff;\n        border: 1px solid #eef0f4;\n        border-radius: 12px;\n        font-family: 'Manrope-Bold';\n        font-size: 15px;\n        color: #23252E;\n    }\n    .mobileMenuToggle span {\n        display: inline-flex;\n        align-items: center;\n        gap: 10px;\n    }\n    .mobileMenuToggle .toggleArrow {\n        transition: transform 0.25s ease;\n    }\n    .mobileMenuToggle .toggleArrow.open {\n        transform: rotate(180deg);\n    }\n    .leftTabcustom .tabBtnbox {\n        display: none;\n        margin-top: 12px;\n    }\n    .leftTabcustom .tabBtnbox.open {\n        display: block;\n    }\n}\n\n.skeleton {\n    text-decoration: unset !important;\n}\n\n.customBtnGold {\n    background: var(--gold-color);\n    width: 100px;\n    font-family: 'Manrope-Bold';\n    border-radius: 30px;\n    min-height: 45px;\n    color: #23252E;\n    outline: unset;\n    border: unset;\n}\n\n.profileBackbtnContainer {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.custom-switch {\n    cursor: pointer;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.two {\n    width: calc(50% - 10px);\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.three {\n    width: calc(100% - 10px);\n}\n\n\n.detailsMore .accordion-body .ourbtnsec .btn.single {\n    width: calc(100%);\n}\n\n.rightProfile .rightProfileMain .userPersonaldet ul li span.black {\n    word-break: break-all;\n}\n\n.flatpickr-day.endRange {\n    background: var(--gold-color) !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    /* color: #fff; */\n    border-color: var(--gold-color) !important;\n}\n\n.rangeMode .flatpickr-day {\n    border-radius: 0 !important;\n}\n\n.flatpickr-day.selected.startRange,\n.flatpickr-day.startRange.startRange,\n.flatpickr-day.endRange.startRange {\n    border-radius: 50px 0 0 50px !important;\n}\n\n.flatpickr-day.selected.endRange,\n.flatpickr-day.startRange.endRange,\n.flatpickr-day.endRange.endRange {\n    border-radius: 0 50px 50px 0 !important;\n}\n\n.customBtnGold {\n    background: var(--gold-color);\n    width: 100px;\n    font-family: 'Manrope-Bold';\n    border-radius: 30px;\n    min-height: 45px;\n    color: #23252E;\n    outline: unset;\n    border: unset;\n}\n\n.profileBackbtnContainer {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.finance_Payment .sub_filter .tour_status_drop {\n    min-width: 200px !important;\n    width: unset;\n}\n\n.finance_Payment .status_select .clickTo input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    margin-right: 0px;\n    left: 0;\n    top: 0;\n    height: 20px;\n    width: 20px;\n    border-radius: 4px;\n    z-index: 55;\n    cursor: pointer;\n}\n\n.finance_Payment .status_select .clickTo input[type=\"radio\"]+.keyword-label::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    cursor: pointer;\n    height: 20px;\n    border: 2px solid #CBD5E1;\n    background-color: #fff;\n    border-radius: 50%;\n}\n\n.finance_Payment .status_select .clickTo input[type=\"radio\"]:checked+.keyword-label::after {\n    content: '\\f00c';\n    position: absolute;\n    font-family: 'fontawesome';\n    left: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 10px;\n    color: #000;\n    background-color: var(--gold-color);\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    border-radius: 50%;\n    padding-top: 5px;\n}\n\n.finance_Payment .sub_filter .added_filer a:first-child {\n    border-right: 0;\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n}\n\n.finance_Payment .sub_filter .added_filer a:nth-child(2) {\n    border-top-left-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;\n    border-top-right-radius: 6px !important;\n    border-bottom-right-radius: 6px !important;\n    display: flex;\n    align-items: center;\n}\n\n.finance_Payment .sub_filter .added_filer a span {\n    color: #64748B;\n    font-size: 13px !important;\n}\n\n.added_filer {\n    display: flex;\n}\n\n.finance_Payment .sub_filter .added_filer a i {\n    margin-left: 0 !important;\n}\n\n.finance_Payment .sub_filter .added_filer a:nth-child(2):hover {\n    background-color: #d4d4d89e;\n}\n\n.topstatus {\n    font-size: 12px !important;\n    padding: 4px 10px !important;\n}\n\n.bottom-0 {\n    bottom: 0px !important;\n}\n\n.profile_privacy_sec .profile_privacy ul li .text_name {\n    display: flex;\n    align-items: center;\n}\n\n.profile_privacy_sec .profile_privacy ul li .swicth_box .form-switch .form-check-input {\n    margin-top: 0;\n    cursor: pointer;\n}\n\n.exportBtns {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.exportBtns button {\n    width: 200px;\n}\n\n.exportBtns button:disabled {\n    opacity: 0.7 !important;\n}\n\n.finance_Payment .select2.select2-container .selection .select2-selection {\n    width: 250px;\n}\n\n.whatsappbtn {\n    background-color: #25D366 !important;\n    color: white !important;\n    width: 100% !important;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn i {\n    vertical-align: initial !important;\n}\n\n.form-check-input:checked {\n    background-color: #ecbb33;\n    border-color: #ecbb33;\n}\n\n.form-check-input:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .25rem #e3bd3e63;\n}\n\n.footerPart .footerBox .innerBox .footermenu.fiveBox ul li span img {\n    width: 100% !important;\n    max-width: 30px !important;\n}\n\n/*  */\n.settings-wrapper {\n    max-width: 900px;\n    margin: 2rem auto;\n    background: #fff;\n    border-radius: 20px;\n    padding: 2rem;\n    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.05);\n}\n\n.section-header {\n    font-size: 1.6rem;\n    font-weight: 600;\n    margin-bottom: 2rem;\n}\n\n.payment-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #e0e0e0;\n    border-radius: 16px;\n    padding: 1rem 1.5rem;\n    margin-bottom: 1.2rem;\n    background-color: #fff;\n    transition: box-shadow 0.3s, border-color 0.3s;\n}\n\n.payment-card:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);\n}\n\n.payment-card.default {\n    border: 2px solid var(--gold-color);\n    background-color: #fdfaf2;\n}\n\n.payment-info {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.payment-icon {\n    font-size: 1.8rem;\n    color: #333;\n}\n\n.payment-details {\n    display: flex;\n    flex-direction: column;\n}\n\n.payment-name {\n    font-weight: 600;\n    font-size: 1rem;\n}\n\n.payment-value {\n    font-size: 0.9rem;\n    color: #666;\n}\n\n.payment-actions {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.btn-sm {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.85rem;\n    border-radius: 0.4rem;\n}\n\n.payment-setting-btn {\n    border: unset;\n    /* color: #e3bd3e; */\n    color: #64748f;\n    font-family: 'Manrope-Bold';\n    font-size: medium;\n}\n\n.payment-setting-btn:focus {\n    border: unset;\n    outline: unset;\n    box-shadow: unset;\n}\n\n.default .payment-setting-btn {\n    color: #e3bd3e;\n}\n\n.select2-container {\n    z-index: 9999 !important;\n\n}\n\n.payoutSettingModal .cus-err {\n    position: relative;\n}\n\n.payoutSettingModal .iti,\n.payoutSettingModal .iti--allow-dropdown {\n    margin-bottom: unset;\n}\n\n.productImportLabel {\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    color: #334155 !important;\n    font-family: 'Manrope-SemiBold'\n}\n\n.tour-label {\n    display: flex;\n    align-items: center;\n}\n\n.dot {\n    height: 6px;\n    width: 6px;\n    background-color: #94A3B8;\n    /* Tailwind's gray-400 */\n    border-radius: 50%;\n    margin: 0 10px;\n}\n\n.customBtnRed {\n    background: #ad0707;\n    width: 300px;\n    font-family: 'Manrope-Bold';\n    border-radius: 30px;\n    min-height: 45px;\n    color: white;\n    outline: unset;\n    border: unset;\n}\n\n.rightProfile .rightProfileMain .iti--inline-dropdown .iti__country-list .iti__country {\n    display: flex !important;\n    padding: 8px !important;\n}\n\n.rightProfile .rightProfileMain .iti--inline-dropdown .iti__country-list .iti__country span {\n    font-size: 16px !important;\n}\n\n.listloader {\n    width: 50px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background:\n        radial-gradient(farthest-side, #E3BD3E 94%, #0000) top/8px 8px no-repeat,\n        conic-gradient(#0000 30%, #E3BD3E);\n    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);\n    animation: l13 1s infinite linear;\n}\n\n@keyframes l13 {\n    100% {\n        transform: rotate(1turn)\n    }\n}\n\n\n.actThemeMain .list-loader-container {\n    margin-top: 10px !important;\n    justify-content: unset !important;\n}\n\n.actThemeMain .listloader {\n    width: 30px !important;\n}\n\n.cke_notification_warning {\n    display: none !important;\n}\n\nbody.dark .notfoundLabel {\n    background-color: #2c2c2c !important;\n}\n\nbody.dark .dark_common_modal .modal-body,\nbody.dark .dark_common_modal .modal-content {\n    background-color: var(--dark-box) !important;\n}\n\nbody.dark .dark_common_modal .modal-header .modal-title,\nbody.dark .dark_common_modal label {\n    color: #CBD5E1;\n}\n\nbody.dark .profileImport .userPersonaldet .toptitle h5 {\n    color: #94A3B8 !important;\n    border-color: #475569;\n}\n\nbody.dark .css-t3ipsp-control,\nbody.dark .css-13cymwt-control,\nbody.dark .css-1nmdiq5-menu {\n    background-color: #2c2c2c;\n    color: #CBD5E1;\n}\n\nbody.dark .dark_common_modal .modal-body .card .card-body {\n    background-color: #171202 !important;\n    color: #CBD5E1;\n\n}\n\nbody.dark .dark_common_modal .modal-body .card {\n    border: unset;\n}\n\nbody.dark .dark_common_modal .modal-body .card .boxCard input {\n    background-color: #171202;\n    color: #CBD5E1;\n}\n\nbody.dark .commonFileInputSecond {\n    background-color: var(--body-box) !important;\n    border-color: #334155 !important;\n}\n\nbody.dark .btn-close {\n    filter: invert(1);\n}\n\nbody.dark .permission_modal th,\nbody.dark .permission_modal b {\n    color: #CBD5E1;\n\n}\n\nbody.dark .commonGoldBtn {\n    color: var(--dark-box);\n}\n\nbody.dark .detasilTitle .detasilBox ul li a i,\nbody.dark .subimageBox .dragBox .btnDrag {\n    color: #94A3B8 !important;\n}\n\nbody.dark .detasilTitle .detasilBox ul li a,\nbody.dark .subimageBox .dragBox .btnDrag {\n    background-color: #171202;\n}\n\nbody.dark .tourListbox span.listgray {\n    background-color: #F5A524 !important;\n}\n\nbody.dark .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n    background-color: #171202;\n\n}\n\nbody.dark .select2-search__field {\n    background-color: #171202;\n    color: #CBD5E1;\n}\n\nbody.dark .mainTableBox table thead tr th {\n    background-color: #b1b5c3;\n}\n\n.real-exp-map-search {\n    width: 40%;\n    position: absolute;\n    right: 70px;\n    top: 11px;\n    z-index: 2;\n}\n\n.suggetionContainerThemes.suggestUp ul li a {\n    background-color: #f4e6f9 !important;\n    color: #7b3f7b !important;\n}\n\n.suggetionContainerThemes.suggestUp ul li a i {\n    color: #7b3f7b !important;\n\n}\n\n#tags-tabs,\n#desc-lang-tabs {\n    padding: 0 !important;\n    border-bottom: 2px solid #e0c97a !important;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n\n#tags-tabs .nav-link,\n#desc-lang-tabs .nav-link {\n    color: #6c757d;\n    font-weight: 500;\n    font-size: 14px;\n    padding: 8px 16px;\n    border: 1px solid transparent;\n    border-bottom: none;\n    border-radius: 6px 6px 0 0;\n    transition: color 0.2s, background 0.2s;\n    background: transparent;\n}\n\n#tags-tabs .nav-link:hover,\n#desc-lang-tabs .nav-link:hover {\n    color: #BB8E11;\n    background: #fdf8ec;\n    border-color: #e0c97a #e0c97a transparent;\n}\n\n#tags-tabs .nav-link.active,\n#desc-lang-tabs .nav-link.active {\n    color: #BB8E11 !important;\n    background: #fff !important;\n    border-color: #e0c97a #e0c97a #fff !important;\n    font-weight: 600;\n}\n\n#tags-tabs.nav,\n#desc-lang-tabs.nav {\n    border-radius: unset !important;\n}\n\n.desc-lang-tab-pane {\n    border: 1px solid #e0c97a;\n    border-top: none;\n    padding: 12px;\n    border-radius: 0 0 6px 6px;\n    background: #fff;\n}\n\n.sitting_option {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: 20px;\n    text-align: center;\n    padding-top: 20px;\n}\n\n/* Dashboard welcome hero (redesigned) */\n.welcome-hero {\n    padding: 8px 0 0;\n}\n.welcome-eyebrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n.welcome-eyebrow-line {\n    height: 2px;\n    width: 70px;\n    max-width: 12vw;\n    border-radius: 2px;\n    background: linear-gradient(90deg, transparent, var(--gold-color));\n}\n.welcome-eyebrow-line:last-child {\n    background: linear-gradient(90deg, var(--gold-color), transparent);\n}\n.welcome-eyebrow-text {\n    color: var(--gold-color);\n    font-family: 'Manrope-Bold';\n    font-size: 18px;\n    white-space: nowrap;\n}\n.welcome-eyebrow.work-with .welcome-eyebrow-text {\n    color: #23252E;\n}\n.welcome-title {\n    font-family: 'Manrope-Bold';\n    font-size: 48px;\n    line-height: 1.12;\n    color: #10131a;\n    margin: 0 auto 20px;\n    max-width: 900px;\n}\n.welcome-title .gold {\n    color: var(--gold-color);\n}\n.welcome-subtitle {\n    max-width: 640px;\n    margin: 0 auto 34px;\n    color: #6b7280;\n    font-size: 17px;\n    line-height: 1.6;\n}\n\n/* Provider logo cards (Dashboard welcome hero only) */\n.welcome-hero .sitting_option {\n    grid-template-columns: repeat(5, 1fr);\n}\n.welcome-hero .sitting_option .box_box {\n    background: #ffffff;\n    border: 1px solid #eef0f4;\n    border-radius: 16px;\n    padding: 22px 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 6px 18px rgba(17, 24, 39, 0.05);\n    transition: box-shadow 0.25s ease, transform 0.25s ease;\n}\n.welcome-hero .sitting_option .box_box:hover {\n    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.10);\n    transform: translateY(-3px);\n}\n.welcome-hero .sitting_option .box_box a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n.turitop_bg {\n    background-color: #f4f6f8;\n}\n\n@media (max-width: 1199px) {\n    .welcome-title {\n        font-size: 40px;\n    }\n}\n@media (max-width: 991px) {\n    .welcome-hero .sitting_option {\n        grid-template-columns: repeat(3, 1fr);\n    }\n    .welcome-title {\n        font-size: 34px;\n    }\n    .welcome-subtitle {\n        font-size: 15px;\n    }\n}\n@media (max-width: 575px) {\n    .welcome-hero .sitting_option {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 14px;\n    }\n    .welcome-title {\n        font-size: 27px;\n    }\n    .welcome-eyebrow-text {\n        font-size: 15px;\n    }\n    .welcome-eyebrow-line {\n        width: 34px;\n    }\n}\n\n.sitting_option .box_box svg {\n    width: 60px;\n    height: 60px;\n    color: #515760;\n    transition: 0.3s all;\n}\n\n.sitting_option .box_box img {\n    width: 90px;\n}\n\n.sitting_option .box_box a:hover svg {\n    color: var(--gold-color);\n}\n\n.sitting_option .box_box h6 {\n    color: #23262F;\n    font-family: 'Manrope-Bold';\n}\n\n.path.blue_modal {\n    fill: #006FEE !important;\n}\n\n.com_bgbox {\n    height: 80px;\n    width: 130px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 30px;\n    border-radius: 10px;\n    position: relative;\n}\n\n.com_bgbox .pending_tag {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    background-color: var(--gold-color);\n    padding: 1px 7px;\n    border-radius: 30px;\n    font-size: 10px;\n    color: var(--text-black);\n    display: none;\n}\n\n.com_bgbox.view_pending .pending_tag {\n    display: block;\n}\n\n.sitting_option .box_box .com_bgbox svg {\n    width: 90px;\n    height: 90px;\n}\n\n.bokun_bg {\n    background-color: #000000;\n}\n\n.fareHarbor_bg {\n    background-color: rgb(198 227 255);\n}\n\n.prularo_bg {\n    background-image: linear-gradient(204deg, #161C27 25%, #f2295b 100%);\n}\n\n.rezdy_bg {\n    background-color: #e5ecfa;\n}\n\n.icon-logo .svg-ticket-bg,\n.icon-logo-ticket .svg-ticket-bg {\n    fill: #0a6ece;\n}\n\n.icon-logo .svg-ticket-detail,\n.icon-logo-ticket .svg-ticket-detail {\n    fill: #fff;\n}\n\n.icon-logo .svg-text,\n.icon-logo-text .svg-text,\n.icon-logo-circle-with-text .svg-text {\n    fill: #0a6ece;\n}\n\n.icon-logo .svg-ticket-stroke,\n.icon-logo-ticket .svg-ticket-stroke {\n    fill: #0a6ece;\n    visibility: hidden;\n}\n\n.iti--inline-dropdown .iti__dropdown-content {\n    z-index: 99999 !important;\n}\n\n.step_instruction .step_viewer:not(:last-child) {\n    margin-bottom: 60px;\n}\n\n.step_instruction .first_box h5 {\n    color: #23262F;\n    font-family: 'Manrope-Bold';\n}\n\n.step_instruction .step_viewer h6 {\n    margin-bottom: 20px;\n    font-family: 'Manrope-Medium';\n    font-size: 16px;\n}\n\n.step_instruction .step_viewer h6 strong {\n    font-weight: 900 !important;\n}\n\n.step_instruction .step_viewer h6 a {\n    text-decoration: underline;\n    color: #6c5508;\n}\n\n.step_instruction .step_viewer img {\n    margin-top: 10px;\n}\n\n.step_instruction .step_viewer ul {\n    list-style: disc;\n}\n\n.step_instruction .step_viewer ul {\n    list-style: unset !important;\n    padding-left: 20px;\n}\n\n.step_instruction .step_viewer ul li {\n    list-style: disc;\n    display: list-item;\n    margin-bottom: 10px !important;\n    width: 100% !important;\n}\n\n.step_instruction .step_viewer ul li p {\n    color: #23262F;\n    font-family: 'Manrope-Medium';\n}\n\n.step_instruction .step_viewer .url_copy {\n    display: flex;\n    justify-content: space-between;\n    background-color: #F9F3DC;\n    border-radius: 10px;\n    padding: 10px 20px;\n}\n\n.step_instruction .step_viewer .url_copy p {\n    margin-bottom: 0;\n    font-size: 14px;\n    color: #23262F;\n    font-family: 'Manrope-Medium';\n}\n\n.step_instruction .step_viewer .url_copy .btn_copy {\n    padding: 0;\n    border: none;\n    box-shadow: none;\n}\n\n.step_instruction .step_viewer .url_copy .btn_copy i {\n    margin-right: 5px;\n    vertical-align: middle;\n}\n\n\n.loading-container {\n    /* Full screen setup */\n    min-height: 100vh;\n    width: 100vw;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    /* Trendy Background (Use a solid color or subtle background texture if allowed) */\n    background-color: #f7f9fc;\n    /* Very light background color */\n    /* font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; */\n    color: #333333;\n    -webkit-font-smoothing: antialiased;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n/* Auth Card - The Focus Element */\n.auth-card {\n    /* Glassmorphism/Neumorphism Inspired Look */\n    background: rgba(255, 255, 255, 0.9);\n    /* Semi-transparent white */\n    backdrop-filter: blur(8px);\n    /* Trendy blur effect (if supported) */\n    padding: 50px 40px;\n    border-radius: 16px;\n    /* Smoother, modern corners */\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.03);\n    /* Soft, multi-layer shadow */\n    text-align: center;\n    max-width: 500px;\n    width: 100%;\n    transition: transform 0.3s ease;\n    font-family: 'Manrope-Regular';\n\n}\n\n/* Typography */\n.auth-card h1 {\n    font-size: 28px;\n    /* Larger, bolder heading */\n    /* font-weight: 700; */\n    margin-top: 15px;\n    margin-bottom: 20px;\n    color: #1a1a1a;\n    line-height: 1.2;\n    font-family: 'Manrope-Bold';\n}\n\n.auth-card p {\n    font-size: 15px;\n    color: #555555;\n    margin: 8px 0;\n}\n\n.small-text {\n    font-size: 13px;\n    margin-top: 25px;\n    color: #999999;\n    font-style: italic;\n}\n\n/* Branded Spinner */\n.spinner {\n    display: inline-block;\n    width: 60px;\n    height: 60px;\n    position: relative;\n    /* margin-bottom: 20px; */\n}\n\n.spinner:before {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    height: 100%;\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    /* Change this color to your brand's primary color, e.g., a blue or green */\n    border-top-color: var(--gold-color);\n    border-radius: 50%;\n    animation: spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    /* Smoother animation curve */\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/*  */\n/* Page Wrapper */\n.providers-page {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 24px;\n}\n\n.providers-title {\n    font-size: 20px;\n    font-weight: 600;\n    margin-bottom: 20px;\n}\n\n/* Provider Card */\n.provider-card {\n    border-radius: 14px;\n    margin-bottom: 18px;\n    border: none;\n    /* box-shadow: 0 8px 22px rgba(0, 0, 0, 0.06); */\n    overflow: hidden;\n}\n\n/* Accordion Header */\n.provider-card .accordion-button {\n    background-color: #f8fafc;\n    padding: 18px 22px;\n}\n\n.provider-card .accordion-button:not(.collapsed) {\n    /* background-color: #eef4ff; */\n    color: #000;\n}\n\n.provider-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.provider-name {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.provider-badge {\n    font-size: 12px;\n    padding: 4px 8px;\n}\n\n/* Body */\n.provider-body {\n    padding: 24px;\n}\n\n/* Logo */\n/* .provider-logo {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n} */\n\n/*  */\n.hero-section {\n    padding: 20px;\n    /* background: linear-gradient(to bottom, #f3ead2, #ffffff); */\n    text-align: center;\n    font-family: 'Manrope-Regular';\n}\n\n.hero-section>h2 {\n    font-size: 1.8rem;\n    color: #333;\n    font-family: 'Manrope-Regular';\n}\n\n.hero-title {\n    font-size: 3rem;\n    font-weight: 800;\n    color: #1e1e1e;\n    line-height: 1.2;\n    font-family: 'Manrope-Bold';\n}\n\n.highlight {\n    color: #e3bd3e;\n    /* your theme */\n}\n\n.hero-subtitle {\n    margin-top: 18px;\n    font-size: 1.15rem;\n    color: #555;\n}\n\n.hero-btn {\n    margin-top: 35px;\n    background: #e3bd3e;\n    color: #fff;\n    border-radius: 40px;\n    padding: 14px 34px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    border: none;\n    transition: 0.3s;\n}\n\n.hero-btn:hover {\n    background: #c5a132;\n}\n\n/* =========================================================\n   Dashboard \"Visibility\" hero (v2)\n   ========================================================= */\n.hero-section-v2 {\n    position: relative;\n    overflow: hidden;\n    padding: 50px 24px 44px;\n    border-radius: 24px;\n    background:\n        radial-gradient(circle at 12% 16%, rgba(227, 189, 62, 0.10), transparent 42%),\n        radial-gradient(circle at 88% 6%, rgba(227, 189, 62, 0.08), transparent 40%);\n}\n.hero-section-v2 > * {\n    position: relative;\n    z-index: 1;\n}\n.hero-blob {\n    position: absolute;\n    border-radius: 50%;\n    background: rgba(227, 189, 62, 0.12);\n    z-index: 0;\n    pointer-events: none;\n}\n.hero-blob-1 {\n    width: 240px;\n    height: 240px;\n    top: -70px;\n    left: -80px;\n}\n.hero-blob-2 {\n    width: 150px;\n    height: 150px;\n    bottom: -55px;\n    left: 7%;\n    background: rgba(227, 189, 62, 0.08);\n}\n.hero-dots {\n    position: absolute;\n    top: 40px;\n    right: 44px;\n    width: 92px;\n    height: 60px;\n    background-image: radial-gradient(rgba(227, 189, 62, 0.45) 1.5px, transparent 1.6px);\n    background-size: 12px 12px;\n    opacity: 0.5;\n    z-index: 0;\n    pointer-events: none;\n}\n\n/* Pill badge */\n.hero-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 24px;\n    background: #ffffff;\n    border: 1px solid #f2e6bf;\n    border-radius: 40px;\n    box-shadow: 0 6px 18px rgba(227, 189, 62, 0.12);\n    color: #1b2333;\n    font-family: 'Manrope-Bold';\n    font-size: 16px;\n    margin-bottom: 26px;\n}\n.hero-badge svg {\n    color: var(--gold-color);\n    flex: 0 0 auto;\n}\n\n/* Title with gold swoosh underline */\n.hero-section-v2 .hero-title {\n    font-size: 3.4rem;\n    line-height: 1.12;\n    color: #101828;\n    max-width: 900px;\n    margin: 0 auto 22px;\n}\n.hero-section-v2 .highlight {\n    position: relative;\n    color: var(--gold-color);\n    white-space: nowrap;\n}\n.hero-section-v2 .highlight::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -12px;\n    height: 12px;\n    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 12' preserveAspectRatio='none'%3E%3Cpath d='M2 8 C 55 1, 150 1, 198 6' stroke='%23e3bd3e' stroke-width='3' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\") no-repeat center / 100% 100%;\n}\n\n.hero-section-v2 .hero-subtitle {\n    max-width: 790px;\n    margin: 0 auto 36px;\n    font-size: 1.05rem;\n    line-height: 1.7;\n    color: #4b5563;\n    text-align: center;\n}\n\n/* Feature row */\n.hero-features {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: nowrap;\n    margin: 0 auto 38px;\n    max-width: 920px;\n}\n.hero-feature {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px 16px;\n    text-align: left;\n}\n.hero-feature:not(:last-child) {\n    border-right: 1px solid #eadfbf;\n}\n.hero-feature-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    background: rgba(227, 189, 62, 0.14);\n    color: var(--gold-color);\n    flex: 0 0 auto;\n}\n.hero-feature p {\n    margin: 0;\n    font-family: 'Manrope-Bold';\n    font-size: 15px;\n    color: #1b2333;\n    line-height: 1.25;\n    max-width: 92px;\n    white-space: normal;\n}\n\n/* CTA with spark decorations */\n.hero-cta-wrap {\n    position: relative;\n    display: inline-block;\n}\n.hero-cta-wrap::before,\n.hero-cta-wrap::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    width: 24px;\n    height: 32px;\n    transform: translateY(-50%);\n    background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 32'%3E%3Cg stroke='%23e3bd3e' stroke-width='2.4' stroke-linecap='round' fill='none'%3E%3Cpath d='M21 5 L12 10'/%3E%3Cpath d='M23 16 L13 16'/%3E%3Cpath d='M21 27 L12 22'/%3E%3C/g%3E%3C/svg%3E\") no-repeat center / contain;\n}\n.hero-cta-wrap::before {\n    left: -36px;\n}\n.hero-cta-wrap::after {\n    right: -36px;\n    transform: translateY(-50%) scaleX(-1);\n}\n\n.hero-section-v2 .hero-btn {\n    margin-top: 0;\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    background: linear-gradient(180deg, #e8c65a 0%, #d9ab2f 100%);\n    color: #1b2333;\n    font-family: 'Manrope-Bold';\n    padding: 15px 42px;\n    font-size: 1.05rem;\n    box-shadow: 0 10px 24px rgba(217, 171, 47, 0.35);\n}\n.hero-section-v2 .hero-btn:hover {\n    background: linear-gradient(180deg, #e2bd45 0%, #c9992a 100%);\n}\n.hero-btn-arrow {\n    font-size: 1.2rem;\n    line-height: 1;\n}\n\n@media (max-width: 991px) {\n    .hero-section-v2 .hero-title {\n        font-size: 2.4rem;\n    }\n    .hero-badge {\n        font-size: 14px;\n    }\n}\n@media (max-width: 767px) {\n    .hero-section-v2 {\n        padding: 36px 16px 32px;\n    }\n    .hero-section-v2 .hero-title {\n        font-size: 1.9rem;\n    }\n    .hero-features {\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n    .hero-feature {\n        flex: 0 0 calc(50% - 4px);\n        padding: 10px 12px;\n        justify-content: flex-start;\n    }\n    .hero-feature p {\n        max-width: none;\n    }\n    .hero-feature:not(:last-child) {\n        border-right: none;\n    }\n    .hero-feature p {\n        font-size: 14px;\n    }\n    .hero-badge span {\n        text-align: left;\n    }\n}\n@media (max-width: 420px) {\n    .hero-feature {\n        flex: 0 0 100%;\n    }\n}\n\n\n.pricing-card {\n    font-family: 'Manrope-Regular';\n    /* border: 2px solid #d4b463; */\n    border-radius: 20px;\n    padding: 2rem;\n    text-align: center;\n    background-color: white;\n    transition: all 0.3s ease;\n    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); */\n}\n\n.pricing-card:hover {\n    /* box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12); */\n}\n\n.pricing-price {\n    font-size: 2.4rem;\n    font-weight: 600;\n    color: #1a1a1a;\n    font-family: 'Manrope-Bold';\n}\n\n.pricing-price > h6 {\n    font-family: 'Manrope-Regular';\n    margin-bottom: 0;\n}\n\n.pricing-credits {\n    font-size: 2.4rem;\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    gap: 7px;\n    color: #00000061;\n    font-family: 'Manrope-Bold';\n}\n\n.pricing-credits-amount {\n    font-family: 'Manrope-Regular';\n    font-size: 2rem;\n}\n\n.pricing-credits-value {\n    text-align: left;\n    font-size: 0.9rem;\n}\n\n.page-heading {\n    font-family: 'Manrope-Bold';\n}\n\n.pricing-title {\n    color: var(--google-blue);\n    font-size: 26px;\n    font-weight: 600;\n}\n\n.pricing-card small.sup {\n    font-size: 14px;\n    vertical-align: super;\n}\n\n.pricing-btn {\n    color: #fff;\n    background-color: #e3bd3e;;\n    border-radius: 40px;\n    padding: 12px 30px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: 0.3s;\n    font-size: 1rem;\n}\n\n.pricing-btn:hover {\n    background: #c5a132;\n    color: #fff;\n}\n\n/* Payment css */\n.titlebox {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n    margin-bottom: 30px;\n    font-family: 'Manrope-Regular';\n}\n\n.titlebox > h4{\n    color: #23252E;\n    font-family: 'Gilroy-Bold';\n    margin-bottom: 0;\n}\n\n.titlebox > span{\n    padding: 5px 15px;\n    border-radius: 30px;\n    background-color: #F0FDF4 !important;\n    font-size: 20px;\n    font-family: 'Manrope-Bold';\n    color: #24D164;\n}\n\n.nav-justified .nav-item,\n.nav-justified>.nav-link {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n}\n\n.confirm_left .tab-pane .checkAndGo:not(:last-child) {\n    margin-bottom: 10px;\n}\n\n.tandcMainDiv {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.tandcLink {\n    color: #ECBB33 !important;\n    text-decoration: underline;\n    font-size: 16px;\n    font-family: 'Manrope-Medium';\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo .keyword-label {\n    font-size: 16px;\n    color: #171202;\n    font-family: 'Manrope-Medium';\n}\n\n.confirm_left .tab-pane .registerBox .form-group.cradImg {\n    position: relative;\n}\n\n.registerBox .form-group label {\n    color: #292929;\n    font-size: 14px;\n    font-family: 'Manrope-Medium';\n    padding-bottom: 10px;\n}\n\n.stripe-custom-form .commonInputSecond {\n    padding: 13px !important;\n}\n\n.confirm_left .paymentTab {\n    margin-bottom: 30px;\n}\n\n.confirm_left .paymentTab .nav-tabs {\n    border-bottom: none;\n    gap: 10px;\n    margin-bottom: 30px;\n    overflow-y: hidden;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    scrollbar-width: none;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link img.white {\n    display: none;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link.active img.white {\n    display: block;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link.active img.black {\n    display: none;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link {\n    color: #5D4709;\n    font-size: 14px;\n    font-family: 'Manrope-Bold';\n    border: 1px solid #FDF7E8;\n    border-radius: 6px;\n    background-color: #FFFFFF;\n    min-height: 40px;\n    box-shadow: 0 0.62px 6.5px #B7B7B714;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.provider-logo svg {\n    max-width: 120px;\n    max-height: 50px;\n}\n\n/* Connected State */\n.provider-connected {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 24px;\n}\n\n.provider-label {\n    font-size: 13px;\n    color: #6b7280;\n    margin-bottom: 4px;\n}\n\n.provider-value {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 6px;\n}\n\n.provider-success {\n    font-size: 13px;\n    color: #16a34a;\n}\n\n/* Connect State */\n.provider-connect {\n    max-width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px\n}\n\n.provider-input {\n    /* margin-bottom: 14px; */\n    padding: 10px 14px;\n    border-radius: 8px;\n}\n\n/* Buttons */\n.provider-btn {\n    border-radius: 8px;\n    padding: 8px 18px;\n    font-weight: 500;\n}\n.bokunDropBox .disabled{\n    pointer-events: none;\n    opacity: 0.6;\n}\n\n/* Mobile header menu - user info block */\n.mobileUserInfo {\n    padding: 4px 0 12px;\n    margin-bottom: 8px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n.mobileUserInfo h6 {\n    margin: 0 0 2px;\n    font-size: 16px;\n    font-weight: 700;\n    color: inherit;\n}\n.mobileUserInfo p {\n    margin: 0;\n    font-size: 13px;\n    opacity: 0.7;\n}\n\n/* =========================================================\n   Providers page - redesigned cards (v2)\n   ========================================================= */\n.providers-grid-v2 {\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n    font-family: 'Manrope-Regular', sans-serif;\n}\n\n/* Per-provider accent colors (drive accent bar, badge, button, gradient) */\n.provider-card-v2 {\n    --accent: #22c55e;\n    --accent-soft: rgba(34, 197, 94, 0.10);\n    --media-from: #f0fdf4;\n    --media-to: #ffffff;\n}\n.provider-card-v2.provider-fareharbor {\n    --accent: #0a6ece;\n    --accent-soft: rgba(10, 110, 206, 0.10);\n    --media-from: #eff6ff;\n    --media-to: #ffffff;\n}\n.provider-card-v2.provider-pluralo {\n    --accent: #e73e46;\n    --accent-soft: rgba(231, 62, 70, 0.10);\n    --media-from: #fef2f2;\n    --media-to: #ffffff;\n}\n.provider-card-v2.provider-turitop {\n    --accent: #2aa3a8;\n    --accent-soft: rgba(42, 163, 168, 0.10);\n    --media-from: #eefcfb;\n    --media-to: #ffffff;\n}\n\n.provider-card-v2 {\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    background: #ffffff;\n    border: 1px solid #eef0f4;\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n/* Left accent bar */\n.provider-card-v2::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 5px;\n    height: 100%;\n    background: var(--accent);\n    z-index: 2;\n}\n\n/* Media / logo zone with soft gradient */\n.provider-media {\n    position: relative;\n    flex: 0 0 240px;\n    max-width: 240px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 28px 24px;\n    background: linear-gradient(135deg, var(--media-from) 0%, var(--media-to) 100%);\n    border-right: 1px solid #f1f2f6;\n}\n\n.provider-logo-v2 {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.provider-logo-v2 svg {\n    max-width: 140px;\n    /* max-height: 48px; */\n    height: auto;\n}\n.provider-logo-v2 img {\n    max-width: 120px;\n    height: auto;\n}\n.provider-bokun-logo {\n    max-width: 100px !important;\n}\n.provider-turitop-logo {\n    max-width: 130px !important;\n}\n\n/* Pluralo + Octo stacked logos */\n.provider-logo-stack {\n    flex-direction: column;\n    gap: 14px;\n}\n.provider-plus {\n    font-size: 20px;\n    font-weight: 700;\n    color: #1f2937;\n}\n\n/* Decorative dotted pattern in the media zone */\n.provider-dots {\n    position: absolute;\n    bottom: 14px;\n    left: 18px;\n    width: 60px;\n    height: 34px;\n    background-image: radial-gradient(var(--accent) 1.4px, transparent 1.6px);\n    background-size: 10px 10px;\n    opacity: 0.35;\n    z-index: 0;\n}\n\n/* Right content area */\n.provider-content {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: end;\n    gap: 24px;\n    padding: 22px 26px;\n    min-width: 0;\n}\n\n.provider-content-main {\n    flex: 1 1 40%;\n    min-width: 0;\n}\n.provider-title-v2 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 12px;\n    font-family: 'Manrope-Bold', sans-serif;\n}\n\n.provider-detail-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n.provider-detail-row + .provider-detail-row {\n    margin-top: 12px;\n}\n.provider-detail-icon {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border-radius: 9px;\n    background: #f3f4f6;\n    color: #6b7280;\n}\n.provider-detail-label {\n    font-size: 13px;\n    color: #9ca3af;\n    margin: 0 0 2px;\n}\n\n/* Integration key label + eye toggle */\n.provider-key-label-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.provider-eye-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: #f9fafb;\n    color: #6b7280;\n    cursor: pointer;\n    transition: color 0.2s ease, border-color 0.2s ease;\n}\n.provider-eye-btn:hover {\n    color: var(--accent);\n    border-color: var(--accent);\n}\n.provider-detail-value {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n    word-break: break-word;\n}\n\n/* Status column with vertical divider */\n.provider-content-status {\n    flex: 1 1 34%;\n    min-width: 0;\n    padding-left: 24px;\n    border-left: 1px solid #eef0f4;\n    min-height: 48px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n.provider-status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--accent);\n    margin-bottom: 6px;\n}\n.provider-check-icon {\n    color: var(--accent);\n}\n.provider-status-text {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.45;\n}\n\n/* Action column */\n.provider-content-action {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n}\n\n.provider-btn-v2 {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 11px 22px;\n    border-radius: 10px;\n    font-size: 15px;\n    font-weight: 600;\n    border: 1.5px solid var(--accent);\n    background: transparent;\n    color: var(--accent);\n    white-space: nowrap;\n    transition: background 0.2s ease, color 0.2s ease;\n}\n.provider-btn-v2:hover,\n.provider-btn-v2:focus,\n.provider-btn-v2:active {\n    background: var(--accent) !important;\n    border-color: var(--accent) !important;\n    color: #ffffff !important;\n    box-shadow: none !important;\n}\n.provider-btn-v2 svg {\n    width: 18px;\n    height: 18px;\n}\n\n/* Disconnected state: inputs stacked in the main column */\n.provider-connect-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n}\n.provider-connect-fields .provider-input {\n    padding: 11px 14px;\n    border-radius: 9px;\n    border: 1px solid #e5e7eb;\n}\n.provider-card-v2.is-disconnected .provider-content-status {\n    border-left: none;\n    padding-left: 0;\n    flex: 0 0 auto;\n}\n\n/* Responsive */\n@media (max-width: 991px) {\n    .provider-card-v2 {\n        flex-direction: column;\n    }\n    .provider-media {\n        flex: 0 0 auto;\n        max-width: none;\n        width: 100%;\n        border-right: none;\n        border-bottom: 1px solid #f1f2f6;\n    }\n    .provider-content {\n        flex-wrap: wrap;\n        gap: 18px;\n    }\n    .provider-content-main,\n    .provider-content-status {\n        flex: 1 1 100%;\n    }\n    .provider-content-status {\n        border-left: none;\n        padding-left: 0;\n    }\n    .provider-content-action {\n        flex: 1 1 100%;\n    }\n    .provider-content-action .provider-btn-v2 {\n        width: 100%;\n        justify-content: center;\n    }\n}\n.provider-card .accordion-header .accordion-button:focus {\n    box-shadow: unset !important;\n}\n.provider-card .accordion-header .accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n.confirm_left .paymentTab .nav-tabs .nav-link svg {\n    margin-right: 5px;\n    vertical-align: middle;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link.active {\n    color: #fff;\n    background-color: #2F2304;\n    border-color: #2F2304;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link.active svg>path {\n    fill: #fff;\n}\n\n.confirm_left .tab-pane .registerBox .box-box {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.confirm_left .tab-pane .registerBox .box-box .form-group {\n    width: calc(50%);\n}\n\n.confirm_left .tab-pane .registerBox .form-group.cradImg {\n    position: relative;\n}\n\n.confirm_left .tab-pane .registerBox .form-group.cradImg img {\n    position: absolute;\n    top: 65%;\n    right: 10px;\n    transform: translateY(-30%);\n    border: 1px solid #D9D9D9;\n    padding: 2px;\n    border-radius: 2.5px;\n    width: 100%;\n    max-width: 35px;\n}\n\n.confirm_left .tab-pane .registerBox .box-box .form-group input::placeholder {\n    color: #BDBDBD;\n    font-size: 14px;\n    font-family: 'Manrope-Medium';\n}\n\n.confirm_left .tab-pane .checkAndGo:not(:last-child) {\n    margin-bottom: 10px;\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo {\n    position: relative;\n    padding-left: 28px;\n    margin-bottom: 5px;\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo .keyword-label {\n    font-size: 16px;\n    color: #171202;\n    font-family: 'Manrope-Medium';\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo .keyword-label a {\n    color: #ECBB33;\n    text-decoration: underline;\n}\n\n.confirm_left .tab-pane .checkAndGo p {\n    font-size: 16px;\n    color: #171202;\n    font-family: 'Manrope-Medium';\n}\n\n.confirm_left .tab-pane .checkAndGo p a {\n    color: #ECBB33;\n    text-decoration: underline;\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo input[type=\"checkbox\"] {\n    position: absolute;\n    opacity: 0;\n    margin-right: 0px;\n    left: 0;\n    top: 0;\n    height: 18px;\n    width: 18px;\n    border-radius: 4px;\n    z-index: 55;\n    cursor: pointer;\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo input[type=\"checkbox\"]+.keyword-label::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 18px;\n    cursor: pointer;\n    height: 18px;\n    border: 2px solid #CBD5E1;\n    background-color: #fff;\n    border-radius: 5px;\n}\n\n.confirm_left .tab-pane .checkAndGo .clickTo input[type=\"checkbox\"]:checked+.keyword-label::after {\n    content: '\\f00c';\n    position: absolute;\n    font-family: 'fontawesome';\n    left: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #fff;\n    background-color: var(--gold-color);\n    width: 18px;\n    height: 18px;\n    text-align: center;\n    border-radius: 4px;\n    padding-top: 1px;\n}\n\n.stripe-custom-form .card-branding {\n    border: unset !important;\n}\n\n.confirm_left .registerBox .onlyText p {\n    color: #475569;\n    font-size: 14px;\n}\n\n.titleWithLinks{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.ads-status .form-check-input:not(:checked):focus {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\") !important;\n}\n\n/*  */\n\n.payment-container {\n    /* background: rgba(255, 255, 255, 0.95); */\n    padding: 0px 40px;\n    width: 420px;\n    text-align: center;\n    border-radius: 16px;\n    /* box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.12); */\n    position: relative;\n    backdrop-filter: blur(10px);\n}\n\n.payment-icon {\n    width: 80px;\n    height: 80px;\n    background: #e3bd3e;\n    color: white;\n    font-size: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    margin: 0 auto;\n    box-shadow: 0px 5px 15px rgba(227, 189, 62, 0.3);\n}\n\n.processing-title {\n    font-size: 30px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    color: #23262F;\n    font-family: 'Manrope-SemiBold';\n}\n\n.processing-loading-text {\n    font-size: 16px;\n    font-weight: 700;\n    color: #94A3B8;\n    font-family: 'Manrope-Regular';\n}\n\n.processing-expire-note {\n    font-size: 16px;\n    font-weight: 600;\n    color: #475569;\n    font-family: 'Manrope-Regular';\n}\n\n.cancelRedBtn {\n    background-color: #e53935;\n    /* Bright red */\n    color: #fff;\n    /* White text */\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 500;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.cancelRedBtn:hover {\n    background-color: #c62828;\n    /* Darker red on hover */\n}\n\n/*  */\n.alertMessage {\n    background-color: #e3bd3e;\n    color: #c62828;\n    margin: 0;\n    padding: 10px;\n    border-radius: 20px;\n}\n\n.disabled-btn {\n    opacity: 50%;\n    cursor: not-allowed;\n}\n\n.sectionTitle {\n    font-size: 18px;\n    font-weight: 700;\n    color: #111827;\n    margin-bottom: 16px;\n}\n\n.sectionTitle:not(:first-of-type) {\n    margin-top: 16px;\n}\n\n.show_visitor {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 8px;\n}\n\n.show_visitor .comBgGray {\n    background-color: #f6f6f6;\n    padding: 1px 6px;\n    border-radius: 5px;\n    border: 1px solid #dcdee0;\n    min-height: 28px;\n    vertical-align: middle;\n}\n\n.show_visitor .comBgGray i {\n    font-size: 14px;\n    margin-right: 4px;\n}\n\n.listText .book_count {\n    font-size: 14px;\n    color: #23262F;\n    font-family: 'Manrope-Bold';\n}\n\n.rightTabcontent .listBoxproduct .listEditBox .btnGold {\n    background-color: var(--gold-color);\n    color: var(--text-black) !important;\n    margin-top: 20px;\n\n}\n\n/* ==========================================================================\n   Footer redesign (shared by logged-out DefaultLayout & logged-in DashboardLayout)\n   Markup: src/components/Footer.jsx  |  overrides base public/assest/css/style.css\n   ========================================================================== */\n\n.txFooter .footerBox {\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* --- Top grid: Brand | Support | Need Help | Stay Connected --- */\n.txFooter .txFooterGrid {\n    display: grid;\n    grid-template-columns: 1.4fr 1fr 1.3fr 1.2fr;\n    gap: 40px;\n    padding-bottom: 40px;\n}\n\n.txFooter .txFooterGrid h4 {\n    color: var(--gold-color, #ecbb33);\n    font-family: 'Gilory-SemiBold', sans-serif;\n    font-size: 13px;\n    letter-spacing: 1.5px;\n    text-transform: uppercase;\n    margin-bottom: 22px;\n}\n\n/* --- Brand column --- */\n.txFooter .txFooterLogo {\n    display: inline-block;\n    margin-bottom: 20px;\n}\n\n.txFooter .txFooterBrand .txFooterLogo img {\n    max-width: 190px;\n    width: 100%;\n}\n\n.txFooter .txFooterBrand p {\n    color: #888e9d;\n    font-family: 'Poppins-Regular', sans-serif;\n    font-size: 13px;\n    line-height: 1.7;\n    max-width: 280px;\n    margin: 0;\n}\n\n/* --- Support links column --- */\n.txFooter .txFooterSupport ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.txFooter .txFooterSupport ul li {\n    margin-bottom: 12px;\n}\n\n.txFooter .txFooterSupport ul li a {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    color: #c7ccd6;\n    font-family: 'Gilory-SemiBold', sans-serif;\n    font-size: 14px;\n    text-decoration: none;\n    transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.txFooter .txFooterSupport ul li a i {\n    font-size: 12px;\n    color: #6b7280;\n    transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.txFooter .txFooterSupport ul li a:hover {\n    color: var(--gold-color, #ecbb33);\n}\n\n.txFooter .txFooterSupport ul li a:hover i {\n    color: var(--gold-color, #ecbb33);\n    transform: translateX(3px);\n}\n\n/* --- Need Help card --- */\n.txFooter .txHelpCard {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 22px 24px;\n    border: 1px solid #f1f4f729;\n    border-radius: 16px;\n    text-decoration: none;\n    background: rgba(255, 255, 255, 0.02);\n    transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.txFooter .txHelpCard:hover {\n    border-color: var(--gold-color, #ecbb33);\n    background: rgba(236, 187, 51, 0.06);\n}\n\n.txFooter .txHelpIcon {\n    flex: 0 0 auto;\n    height: 48px;\n    width: 48px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(236, 187, 51, 0.12);\n    color: var(--gold-color, #ecbb33);\n    font-size: 20px;\n}\n\n.txFooter .txHelpBody {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.txFooter .txHelpTitle {\n    color: var(--white-color, #fff);\n    font-family: 'Gilory-SemiBold', sans-serif;\n    font-size: 17px;\n}\n\n.txFooter .txHelpDesc {\n    color: #888e9d;\n    font-family: 'Poppins-Regular', sans-serif;\n    font-size: 13px;\n}\n\n.txFooter .txHelpLink {\n    color: var(--gold-color, #ecbb33);\n    font-family: 'Gilory-SemiBold', sans-serif;\n    font-size: 13px;\n    margin-top: 2px;\n}\n\n/* --- Stay Connected column --- */\n.txFooter .txSocial {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 28px 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: nowrap;\n}\n\n.txFooter .txSocial li {\n    flex: 0 0 auto;\n}\n\n.txFooter .txSocial li a {\n    height: 36px;\n    width: 36px;\n    border-radius: 9px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f1f4f729;\n    color: var(--white-color, #fff);\n    font-size: 15px;\n    text-decoration: none;\n    transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.txFooter .txSocial li a:hover {\n    background-color: var(--gold-color, #ecbb33);\n    color: var(--text-black, #14181f);\n}\n\n.txFooter .txSocial li a svg {\n    width: 16px;\n    height: 16px;\n}\n\n.txFooter .txPayment {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    column-gap: 12px;\n    row-gap: 10px;\n}\n\n.txFooter .txPayment li span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 30px;\n    width: 44px;\n    padding: 4px 6px;\n    border-radius: 6px;\n    background-color: var(--white-color, #fff);\n    border: 1px solid #e2e6ee;\n}\n\n.txFooter .txPayment li span img {\n    width: 100%;\n    max-width: 32px;\n    height: auto;\n    object-fit: contain;\n}\n\n/* --- Bottom bar --- */\n.txFooter .txFooterBottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    padding-top: 26px;\n    border-top: 1px solid #f1f4f729;\n}\n\n.txFooter .txFooterBottom p {\n    margin: 0;\n    font-size: 13px;\n    color: #888e9d;\n    font-family: 'Manrope-SemiBold', sans-serif;\n}\n\n.txFooter .txSecure {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.txFooter .txSecure i {\n    color: var(--gold-color, #ecbb33);\n    font-size: 12px;\n}\n\n.payment-instructions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: #f8fafc;\n    border: 1px solid #e5e7eb;\n\n    font-size: 13px;\n    line-height: 20px;\n    color: #64748b;\n}\n\n.payment-instructions > i {\n    flex-shrink: 0;\n    color: #64748b;\n}\n\n.payment-instructions a {\n    margin-left: 3px;\n    color: #b8860b;\n    font-weight: 500;\n    text-decoration: none;\n}\n\n.payment-instructions a:hover {\n    text-decoration: underline;\n}\n\n/* --- Responsive --- */\n@media (max-width: 991px) {\n    .txFooter .txFooterGrid {\n        grid-template-columns: 1fr 1fr;\n        gap: 32px;\n    }\n}\n\n@media (max-width: 575px) {\n    .txFooter .txFooterGrid {\n        grid-template-columns: 1fr;\n        gap: 28px;\n    }\n\n    .txFooter .txFooterBrand p {\n        max-width: 100%;\n    }\n\n    .txFooter .txFooterBottom {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n/* Tour starting status info card */\n.tourStatusInfo {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    border: 1px solid #006FEE66;\n    padding: 20px 25px;\n}\n\n.tourStatusInfo .tourStatusHead {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    min-width: 260px;\n}\n\n.tourStatusInfo .tourStatusIcon {\n    width: 46px;\n    height: 46px;\n    min-width: 46px;\n    border-radius: 50%;\n    background-color: #006FEE1A;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tourStatusInfo .tourStatusIcon i {\n    color: #006FEE;\n    font-size: 20px;\n    line-height: 1;\n}\n\n.tourStatusInfo .tourStatusTitle h6 {\n    font-family: 'Manrope-Bold';\n    font-size: 16px;\n    color: var(--text-black);\n    margin-bottom: 2px;\n}\n\n.tourStatusInfo .tourStatusTitle p {\n    font-size: 12px;\n    color: var(--textP-color);\n    margin-bottom: 0;\n}\n\n.tourStatusInfo .tourStatusList {\n    display: flex;\n    align-items: flex-start;\n    flex: 1;\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style: none;\n}\n\n.tourStatusInfo .tourStatusList li {\n    flex: 1;\n    padding: 0 20px;\n}\n\n.tourStatusInfo .tourStatusList li+li {\n    border-left: 1px solid var(--border-color);\n}\n\n.tourStatusInfo .tourStatusList li p {\n    font-size: 13px;\n    color: var(--textP-color);\n    margin: 8px 0 0;\n}\n\n.tourStatusInfo span.comtagSpan {\n    display: inline-block;\n    padding: 0px 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.tourStatusInfo span.comtagSpan.green {\n    background-color: #17C96433;\n    color: #09A54D;\n}\n\n.tourStatusInfo span.comtagSpan.blue {\n    background-color: #006FEE33;\n    color: #006FEE;\n}\n\n.tourStatusInfo span.comtagSpan.yellow {\n    background-color: #FFE69C;\n    color: #B58100;\n}\n\nbody.dark .tourStatusInfo .tourStatusTitle h6 {\n    color: var(--light-text);\n}\n\nbody.dark .tourStatusInfo .tourStatusList li+li {\n    border-left-color: #3a3a3a;\n}\n\n@media (max-width: 991px) {\n    .tourStatusInfo {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n\n    .tourStatusInfo .tourStatusList {\n        width: 100%;\n    }\n\n    .tourStatusInfo .tourStatusList li:first-child {\n        padding-left: 0;\n    }\n}\n\n@media (max-width: 575px) {\n    .tourStatusInfo .tourStatusList {\n        flex-direction: column;\n        gap: 14px;\n    }\n\n    .tourStatusInfo .tourStatusList li {\n        padding: 0;\n    }\n\n    .tourStatusInfo .tourStatusList li+li {\n        border-left: unset;\n        border-top: 1px solid var(--border-color);\n        padding-top: 14px;\n    }\n\n    body.dark .tourStatusInfo .tourStatusList li+li {\n        border-top-color: #3a3a3a;\n    }\n}\n\n/* Payment & Invoicing Rules page */\n.pay_rules .pay_rules_section:not(:last-child) {\n    margin-bottom: 32px;\n}\n\n.pay_rules h5 {\n    color: #23262F;\n    font-family: 'Manrope-Bold';\n    font-size: 20px;\n    margin-bottom: 12px;\n}\n\n.pay_rules p,\n.pay_rules ul li {\n    color: #23262F;\n    font-family: 'Manrope-Medium';\n    font-size: 16px;\n    line-height: 1.7;\n}\n\n.pay_rules p {\n    margin-bottom: 12px;\n}\n\n.pay_rules strong {\n    font-family: 'Manrope-Bold';\n    font-weight: 700;\n}\n\n.pay_rules ul {\n    padding-left: 22px;\n    margin-bottom: 0;\n}\n\n.pay_rules ul li {\n    list-style: disc;\n    display: list-item;\n    margin-bottom: 8px;\n}\n\n.pay_rules ul ul {\n    margin-top: 8px;\n}\n\n.pay_rules ul ul li {\n    list-style: circle;\n}\n\n.pay_rules ul ul ul li {\n    list-style: square;\n}\n\n.pay_rules .pay_rules_mark {\n    background-color: #F9F3DC;\n    color: #6c5508;\n    padding: 1px 5px;\n    border-radius: 4px;\n}\n\n.pay_rules .pay_rules_danger {\n    color: #e73e46;\n}\n\nbody.dark .pay_rules p,\nbody.dark .pay_rules ul li {\n    color: var(--light-text);\n}\n\nbody.dark .pay_rules .pay_rules_mark {\n    background-color: rgba(227, 189, 62, 0.15);\n    color: var(--gold-color);\n}\n\n/* ====== Recharge plans: credits explainer ====== */\n.credits-explainer {\n    width: 100%;\n    background-color: #fff;\n    border: 1px solid #e3bd3e;\n    border-radius: 20px;\n    padding: 1.5rem 2rem;\n    font-family: 'Manrope-Regular';\n}\n\n.credits-explainer h5 {\n    font-family: 'Manrope-Bold';\n    color: #23252E;\n    margin: 0 0 6px;\n}\n\n.credits-explainer > p {\n    color: #888E9D;\n    margin: 0 0 16px;\n}\n\n.credits-steps {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n.credits-step {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    background-color: #f5f5f0;\n    border-radius: 14px;\n    padding: 14px 16px;\n}\n\n.credits-step--wide {\n    grid-column: 1 / -1;\n}\n\n.credits-step-num {\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background-color: #e3bd3e;\n    color: #fff;\n    font-family: 'Manrope-Bold';\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.credits-step strong {\n    display: block;\n    font-family: 'Manrope-Bold';\n    color: #23252E;\n    font-size: .95rem;\n}\n\n.credits-step span:not(.credits-step-num) {\n    color: #888E9D;\n    font-size: .9rem;\n}\n\n.credits-step a {\n    color: #c5a132;\n    font-weight: 600;\n    text-decoration: underline;\n}\n\nbody.dark .credits-explainer {\n    background-color: var(--dark-box);\n}\n\nbody.dark .credits-explainer h5,\nbody.dark .credits-step strong {\n    color: var(--white-color);\n}\n\nbody.dark .credits-step {\n    background-color: var(--body-dark);\n}\n\n@media (max-width: 575px) {\n    .credits-explainer {\n        padding: 1.25rem;\n    }\n\n    .credits-steps {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
